var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });

// src/affinity.ts
var AffinityCriterionEnum = /* @__PURE__ */ function(AffinityCriterionEnum2) {
  AffinityCriterionEnum2["EXPOSURE"] = "EXPOSURE";
  AffinityCriterionEnum2["PREMIUM"] = "PREMIUM";
  AffinityCriterionEnum2["DURATION"] = "DURATION";
  AffinityCriterionEnum2["PARTNER"] = "PARTNER";
  AffinityCriterionEnum2["PRODUCT"] = "PRODUCT";
  AffinityCriterionEnum2["DEADLINE"] = "DEADLINE";
  AffinityCriterionEnum2["ACCEPTING"] = "ACCEPTING";
  AffinityCriterionEnum2["REFUSING"] = "REFUSING";
  AffinityCriterionEnum2["RANDOM"] = "RANDOM";
  AffinityCriterionEnum2["MAXIMUM_COMPENSATION"] = "MAXIMUM_COMPENSATION";
  return AffinityCriterionEnum2;
}({});
var AffinityEnum = /* @__PURE__ */ function(AffinityEnum2) {
  AffinityEnum2["WILLING"] = "WILLING";
  AffinityEnum2["ACCEPTING"] = "ACCEPTING";
  AffinityEnum2["REFUSING"] = "REFUSING";
  return AffinityEnum2;
}({});

// src/auth-attempt.ts
var AuthAttemptApplications = {
  CUSTOMER_HUB: "CUSTOMER_HUB",
  PCUI: "PCUI"
};

// src/baggage-disruption.ts
var BaggageDisruptionTypes = {
  BAGGAGE_LOSS: "BAGGAGE_LOSS",
  BAGGAGE_DELAY: "BAGGAGE_DELAY"
};

// src/battleface/battleface-policy-file-type-enum.ts
var BattlefacePolicyFileTypeEnum = {
  CONFIRMATION_OF_COVERAGE: "confirmation_of_coverage",
  POLICY: "policy"
};

// src/challenge.ts
var ChallengeTypes = {
  TURNSTILE: "turnstile"
};

// src/claims.ts
var ClaimStatusEnum = /* @__PURE__ */ function(ClaimStatusEnum2) {
  ClaimStatusEnum2["ACCEPTED"] = "ACCEPTED";
  ClaimStatusEnum2["MANUAL_VERIFICATION_NEEDED"] = "MANUAL_VERIFICATION_NEEDED";
  ClaimStatusEnum2["REFUND_ERROR"] = "REFUND_ERROR";
  ClaimStatusEnum2["REFUNDABLE"] = "REFUNDABLE";
  ClaimStatusEnum2["REFUNDED"] = "REFUNDED";
  ClaimStatusEnum2["AUTOMATICALLY_REJECTED"] = "AUTOMATICALLY_REJECTED";
  ClaimStatusEnum2["CLAIM_ERROR"] = "CLAIM_ERROR";
  ClaimStatusEnum2["MORE_INFO_NEEDED"] = "MORE_INFO_NEEDED";
  ClaimStatusEnum2["REJECTED"] = "REJECTED";
  return ClaimStatusEnum2;
}({});
var ExternalClaimProviderEnum = /* @__PURE__ */ function(ExternalClaimProviderEnum2) {
  ExternalClaimProviderEnum2["MEETCH"] = "MEETCH";
  return ExternalClaimProviderEnum2;
}({});
var ClaimAcceptedReasonEnum = /* @__PURE__ */ function(ClaimAcceptedReasonEnum2) {
  ClaimAcceptedReasonEnum2["CANCELATION"] = "CANCELATION";
  ClaimAcceptedReasonEnum2["FLIGHT_CANCELED"] = "FLIGHT_CANCELED";
  ClaimAcceptedReasonEnum2["FLIGHT_DELAYED"] = "FLIGHT_DELAYED";
  ClaimAcceptedReasonEnum2["FLIGHT_DIVERTED"] = "FLIGHT_DIVERTED";
  ClaimAcceptedReasonEnum2["REBOOKING"] = "REBOOKING";
  ClaimAcceptedReasonEnum2["GOODWILL_GESTURE"] = "GOODWILL_GESTURE";
  ClaimAcceptedReasonEnum2["BAGGAGE_DISRUPTED"] = "BAGGAGE_DISRUPTED";
  return ClaimAcceptedReasonEnum2;
}({});
var ClaimRejectedReasonEnum = /* @__PURE__ */ function(ClaimRejectedReasonEnum2) {
  ClaimRejectedReasonEnum2["CLAIM_REQUESTED_TOO_LATE"] = "CLAIM_REQUESTED_TOO_LATE";
  ClaimRejectedReasonEnum2["CONTRACT_HAS_BEEN_RENOUNCED"] = "CONTRACT_HAS_BEEN_RENOUNCED";
  ClaimRejectedReasonEnum2["FLIGHT_NOT_CANCELED"] = "FLIGHT_NOT_CANCELED";
  ClaimRejectedReasonEnum2["FLIGHT_CANCELED_TOO_EARLY"] = "FLIGHT_CANCELED_TOO_EARLY";
  ClaimRejectedReasonEnum2["FLIGHT_NOT_DIVERTED"] = "FLIGHT_NOT_DIVERTED";
  ClaimRejectedReasonEnum2["FLIGHT_NOT_DELAYED"] = "FLIGHT_NOT_DELAYED";
  ClaimRejectedReasonEnum2["FLIGHT_LANDED_WITHOUT_DELAY_INFO"] = "FLIGHT_LANDED_WITHOUT_DELAY_INFO";
  ClaimRejectedReasonEnum2["FLIGHT_NOT_DELAYED_ENOUGH"] = "FLIGHT_NOT_DELAYED_ENOUGH";
  ClaimRejectedReasonEnum2["TRIP_HAS_CANCELED_FLIGHTS"] = "TRIP_HAS_CANCELED_FLIGHTS";
  ClaimRejectedReasonEnum2["REJECTED_MANUALLY"] = "REJECTED_MANUALLY";
  ClaimRejectedReasonEnum2["BAGGAGE_DISRUPTIONS_NOT_COVERED"] = "BAGGAGE_DISRUPTIONS_NOT_COVERED";
  ClaimRejectedReasonEnum2["MISMATCH_BETWEEN_DISRUPTED_AND_CHECKED_BAGGAGE"] = "MISMATCH_BETWEEN_DISRUPTED_AND_CHECKED_BAGGAGE";
  ClaimRejectedReasonEnum2["CLAIM_REQUESTED_TOO_EARLY"] = "CLAIM_REQUESTED_TOO_EARLY";
  return ClaimRejectedReasonEnum2;
}({});
var BankDetailsTypeEnum = /* @__PURE__ */ function(BankDetailsTypeEnum2) {
  BankDetailsTypeEnum2["ACCOUNT_NUMBER"] = "ACCOUNT_NUMBER";
  BankDetailsTypeEnum2["IBAN"] = "IBAN";
  BankDetailsTypeEnum2["NOT_HANDLED"] = "NOT_HANDLED";
  return BankDetailsTypeEnum2;
}({});
var ClaimPaymentFlowEnum = /* @__PURE__ */ function(ClaimPaymentFlowEnum2) {
  ClaimPaymentFlowEnum2["B2B2C_MONTHLY"] = "B2B2C_MONTHLY";
  ClaimPaymentFlowEnum2["B2B2C_PER_CLAIM"] = "B2B2C_PER_CLAIM";
  ClaimPaymentFlowEnum2["B2C"] = "B2C";
  return ClaimPaymentFlowEnum2;
}({});
var ClaimPaymentStatusEnum = /* @__PURE__ */ function(ClaimPaymentStatusEnum2) {
  ClaimPaymentStatusEnum2["PENDING"] = "PENDING";
  ClaimPaymentStatusEnum2["ACCEPTED"] = "ACCEPTED";
  ClaimPaymentStatusEnum2["REJECTED"] = "REJECTED";
  return ClaimPaymentStatusEnum2;
}({});

// src/contract.ts
var DeletionReasonEnum = /* @__PURE__ */ function(DeletionReasonEnum2) {
  DeletionReasonEnum2["REPLACEMENT"] = "REPLACEMENT";
  DeletionReasonEnum2["RENOUNCEMENT"] = "RENOUNCEMENT";
  return DeletionReasonEnum2;
}({});

// src/contract-document.ts
var ContractDocumentTypes = {
  CANCELLATION_PROOF: "CANCELLATION_PROOF",
  PROPERTY_IRREGULARITY_REPORT: "PROPERTY_IRREGULARITY_REPORT"
};
var ContractDocumentStatuses = {
  PENDING: "PENDING",
  APPROVED: "APPROVED",
  REJECTED: "REJECTED"
};
var ContractDocumentUploadStatuses = {
  REQUESTED: "REQUESTED",
  COMPLETED: "COMPLETED",
  FAILED: "FAILED"
};
var ContractDocumentUploaders = {
  KOALA_OPERATOR: "KOALA_OPERATOR",
  CUSTOMER: "CUSTOMER"
};

// src/country.ts
var GeographicalAreaEnum = /* @__PURE__ */ function(GeographicalAreaEnum2) {
  GeographicalAreaEnum2["EUROPE"] = "EUROPE";
  GeographicalAreaEnum2["NORTH_AMERICA"] = "NORTH_AMERICA";
  GeographicalAreaEnum2["LOCAL"] = "LOCAL";
  GeographicalAreaEnum2["WORLD"] = "WORLD";
  return GeographicalAreaEnum2;
}({});

// src/country-code.ts
var CountryCodes = [
  "AD",
  "AE",
  "AF",
  "AG",
  "AI",
  "AL",
  "AM",
  "AO",
  "AQ",
  "AR",
  "AS",
  "AT",
  "AU",
  "AW",
  "AX",
  "AZ",
  "BA",
  "BB",
  "BD",
  "BE",
  "BF",
  "BG",
  "BH",
  "BI",
  "BJ",
  "BL",
  "BM",
  "BN",
  "BO",
  "BQ",
  "BR",
  "BS",
  "BT",
  "BV",
  "BW",
  "BY",
  "BZ",
  "CA",
  "CC",
  "CD",
  "CF",
  "CG",
  "CH",
  "CI",
  "CK",
  "CL",
  "CM",
  "CN",
  "CO",
  "CR",
  "CU",
  "CV",
  "CW",
  "CX",
  "CY",
  "CZ",
  "DE",
  "DJ",
  "DK",
  "DM",
  "DO",
  "DZ",
  "EC",
  "EE",
  "EG",
  "EH",
  "ER",
  "ES",
  "ET",
  "FI",
  "FJ",
  "FK",
  "FM",
  "FO",
  "FR",
  "GA",
  "GB",
  "GD",
  "GE",
  "GF",
  "GG",
  "GH",
  "GI",
  "GL",
  "GM",
  "GN",
  "GP",
  "GQ",
  "GR",
  "GS",
  "GT",
  "GU",
  "GW",
  "GY",
  "HK",
  "HM",
  "HN",
  "HR",
  "HT",
  "HU",
  "ID",
  "IE",
  "IL",
  "IM",
  "IN",
  "IO",
  "IQ",
  "IR",
  "IS",
  "IT",
  "JE",
  "JM",
  "JO",
  "JP",
  "KE",
  "KG",
  "KH",
  "KI",
  "KM",
  "KN",
  "KP",
  "KR",
  "KW",
  "KY",
  "KZ",
  "LA",
  "LB",
  "LC",
  "LI",
  "LK",
  "LR",
  "LS",
  "LT",
  "LU",
  "LV",
  "LY",
  "MA",
  "MC",
  "MD",
  "ME",
  "MF",
  "MG",
  "MH",
  "MK",
  "ML",
  "MM",
  "MN",
  "MO",
  "MP",
  "MQ",
  "MR",
  "MS",
  "MT",
  "MU",
  "MV",
  "MW",
  "MX",
  "MY",
  "MZ",
  "NA",
  "NC",
  "NE",
  "NF",
  "NG",
  "NI",
  "NL",
  "NO",
  "NP",
  "NR",
  "NU",
  "NZ",
  "OM",
  "PA",
  "PE",
  "PF",
  "PG",
  "PH",
  "PK",
  "PL",
  "PM",
  "PN",
  "PR",
  "PS",
  "PT",
  "PW",
  "PY",
  "QA",
  "RE",
  "RO",
  "RS",
  "RU",
  "RW",
  "SA",
  "SB",
  "SC",
  "SD",
  "SE",
  "SG",
  "SH",
  "SI",
  "SJ",
  "SK",
  "SL",
  "SM",
  "SN",
  "SO",
  "SR",
  "SS",
  "ST",
  "SV",
  "SX",
  "SY",
  "SZ",
  "TC",
  "TD",
  "TF",
  "TG",
  "TH",
  "TJ",
  "TK",
  "TL",
  "TM",
  "TN",
  "TO",
  "TR",
  "TT",
  "TV",
  "TW",
  "TZ",
  "UA",
  "UG",
  "UM",
  "US",
  "UY",
  "UZ",
  "VA",
  "VC",
  "VE",
  "VG",
  "VI",
  "VN",
  "VU",
  "WF",
  "WS",
  "XK",
  "YE",
  "YT",
  "ZA",
  "ZM",
  "ZW"
];

// src/flight-status.ts
var FlightStatusProviderEnum = /* @__PURE__ */ function(FlightStatusProviderEnum2) {
  FlightStatusProviderEnum2["FLIGHT_STATS"] = "FLIGHT_STATS";
  FlightStatusProviderEnum2["KOALA"] = "KOALA";
  FlightStatusProviderEnum2["OAG"] = "OAG";
  FlightStatusProviderEnum2["PARTNER"] = "PARTNER";
  return FlightStatusProviderEnum2;
}({});
var FlightStatusEnum = /* @__PURE__ */ function(FlightStatusEnum2) {
  FlightStatusEnum2["ACTIVE"] = "ACTIVE";
  FlightStatusEnum2["CANCELED"] = "CANCELED";
  FlightStatusEnum2["DATA_SOURCE_NEEDED"] = "DATA_SOURCE_NEEDED";
  FlightStatusEnum2["DIVERTED"] = "DIVERTED";
  FlightStatusEnum2["LANDED"] = "LANDED";
  FlightStatusEnum2["NOT_OPERATIONAL"] = "NOT_OPERATIONAL";
  FlightStatusEnum2["REDIRECTED"] = "REDIRECTED";
  FlightStatusEnum2["SCHEDULED"] = "SCHEDULED";
  FlightStatusEnum2["TEMPORARILY_DIVERTED"] = "TEMPORARILY_DIVERTED";
  FlightStatusEnum2["UNKNOWN"] = "UNKNOWN";
  return FlightStatusEnum2;
}({});

// src/json-logic-always-true-condition.ts
var JSON_LOGIC_ALWAYS_TRUE_CONDITION = {
  and: [
    true
  ]
};

// src/json-logic-operator.ts
var JSON_LOGIC_LOGICAL_OPERATORS = [
  "AND",
  "OR"
];
var JSON_LOGIC_COMPARATORS = [
  "<=",
  ">=",
  ">",
  "<",
  "==="
];

// src/partner.ts
var PartnerBusinessCategoryEnum = /* @__PURE__ */ function(PartnerBusinessCategoryEnum2) {
  PartnerBusinessCategoryEnum2["TICKET_OTA"] = "TICKET_OTA";
  PartnerBusinessCategoryEnum2["PACKAGE_SELLER"] = "PACKAGE_SELLER";
  PartnerBusinessCategoryEnum2["TAILOR_MADE_LUXURY"] = "TAILOR_MADE_LUXURY";
  PartnerBusinessCategoryEnum2["BUSINESS_TRIP"] = "BUSINESS_TRIP";
  PartnerBusinessCategoryEnum2["PET_RELATED"] = "PET_RELATED";
  PartnerBusinessCategoryEnum2["THEMED_TRIP"] = "THEMED_TRIP";
  PartnerBusinessCategoryEnum2["STAG_PARTY"] = "STAG_PARTY";
  PartnerBusinessCategoryEnum2["AIRLINE"] = "AIRLINE";
  PartnerBusinessCategoryEnum2["HOTEL_RENTAL"] = "HOTEL_RENTAL";
  PartnerBusinessCategoryEnum2["OTHER"] = "OTHER";
  PartnerBusinessCategoryEnum2["WINTER"] = "WINTER";
  PartnerBusinessCategoryEnum2["SUMMER_CAMP"] = "SUMMER_CAMP";
  PartnerBusinessCategoryEnum2["SOFTWARE"] = "SOFTWARE";
  PartnerBusinessCategoryEnum2["CAR_RENTAL"] = "CAR_RENTAL";
  PartnerBusinessCategoryEnum2["BOAT_RENTAL"] = "BOAT_RENTAL";
  PartnerBusinessCategoryEnum2["TICKETING_EVENT"] = "TICKETING_EVENT";
  PartnerBusinessCategoryEnum2["CONCIERGE"] = "CONCIERGE";
  return PartnerBusinessCategoryEnum2;
}({});
var PartnerTierEnum = /* @__PURE__ */ function(PartnerTierEnum2) {
  PartnerTierEnum2["TIER_1"] = "TIER_1";
  PartnerTierEnum2["TIER_2"] = "TIER_2";
  PartnerTierEnum2["TIER_3"] = "TIER_3";
  PartnerTierEnum2["TIER_4"] = "TIER_4";
  return PartnerTierEnum2;
}({});
var PartnerIntegrationModeEnum = /* @__PURE__ */ function(PartnerIntegrationModeEnum2) {
  PartnerIntegrationModeEnum2["FUNNEL"] = "FUNNEL";
  PartnerIntegrationModeEnum2["API"] = "API";
  PartnerIntegrationModeEnum2["CSV"] = "CSV";
  return PartnerIntegrationModeEnum2;
}({});
var PartnerBrandingModeEnum = /* @__PURE__ */ function(PartnerBrandingModeEnum2) {
  PartnerBrandingModeEnum2["KOALA"] = "KOALA";
  PartnerBrandingModeEnum2["WHITE_LABEL"] = "WHITE_LABEL";
  PartnerBrandingModeEnum2["NO_BRANDING"] = "NO_BRANDING";
  PartnerBrandingModeEnum2["CO_BRANDING"] = "CO_BRANDING";
  return PartnerBrandingModeEnum2;
}({});
var PartnerDealOwnerEnum = /* @__PURE__ */ function(PartnerDealOwnerEnum2) {
  PartnerDealOwnerEnum2["LEO"] = "L\xE9o";
  PartnerDealOwnerEnum2["SELIM"] = "Selim";
  PartnerDealOwnerEnum2["JACK"] = "Jack";
  return PartnerDealOwnerEnum2;
}({});
var PartnerAccountGroupEnum = /* @__PURE__ */ function(PartnerAccountGroupEnum2) {
  PartnerAccountGroupEnum2["PARTNER"] = "PARTNER";
  PartnerAccountGroupEnum2["KOALA"] = "KOALA";
  PartnerAccountGroupEnum2["THIRD_PARTY"] = "THIRD_PARTY";
  return PartnerAccountGroupEnum2;
}({});
var PartnerSyncWebhookVersionEnum = /* @__PURE__ */ function(PartnerSyncWebhookVersionEnum2) {
  PartnerSyncWebhookVersionEnum2["V1"] = "V1";
  PartnerSyncWebhookVersionEnum2["V2"] = "V2";
  return PartnerSyncWebhookVersionEnum2;
}({});

// src/pricing-call-mode.ts
var PricingCallMode = /* @__PURE__ */ function(PricingCallMode2) {
  PricingCallMode2["LIVE"] = "LIVE";
  PricingCallMode2["SIMULATION"] = "SIMULATION";
  return PricingCallMode2;
}({});

// src/pricing-factors.ts
var TRIP_PRICING_FACTORS = [
  "departureDate",
  "hoursBeforeDeparture",
  "nbOfJourneys",
  "nbOfTravelers",
  "nbOfStays",
  "modes",
  "nbOfFlightSegments",
  "nbOfBusSegments",
  "nbOfFerrySegments",
  "nbOfTrainSegments",
  "price.amount",
  "price.currency",
  "countries",
  "tripOrigin",
  "tripDestination",
  "originCountry",
  "destinationCountry",
  "departureDayOfWeek",
  "tripDurationInDays",
  "hasConnection",
  "nbOfConnections",
  "maxLayoverDurationInHours",
  "hasOvernightLayover",
  "nbOfStopovers",
  "isMultiDestination",
  "isRoundTrip",
  "isInternational",
  "nbOfDistinctAirlines",
  "airlines",
  "departureContinentPair",
  "numberOfCheckedBags",
  "providerRefundabilityCategories",
  "estimatedProviderRefundAmount",
  "estimatedProviderUncoveredAmount",
  "providerUncoveredAmountRatio"
];
var FLIGHT_PRICING_FACTORS = [
  "price",
  "departureDate",
  "arrivalDate",
  ...TRIP_PRICING_FACTORS.map((k) => `trip.${k}`)
];

// src/product/battleface-bundle-enum.ts
var BattlefaceBundleEnum = {
  COMPREHENSIVE_STANDARD: "COMPREHENSIVE_STANDARD"
};

// src/product/product-enums.ts
var ProductTypeEnum = /* @__PURE__ */ function(ProductTypeEnum2) {
  ProductTypeEnum2["COMPREHENSIVE"] = "COMPREHENSIVE";
  ProductTypeEnum2["FLIGHT_DISRUPTION"] = "FLIGHT_DISRUPTION";
  ProductTypeEnum2["WITHDRAWAL"] = "WITHDRAWAL";
  ProductTypeEnum2["CHANGE_FOR_ANY_REASON"] = "CHANGE_FOR_ANY_REASON";
  ProductTypeEnum2["CANCELLATION_WITHOUT_PROOF"] = "CANCELLATION_WITHOUT_PROOF";
  ProductTypeEnum2["BAGGAGE_DISRUPTION"] = "BAGGAGE_DISRUPTION";
  return ProductTypeEnum2;
}({});
var ProductDistributionModeEnum = /* @__PURE__ */ function(ProductDistributionModeEnum2) {
  ProductDistributionModeEnum2["BROKERAGE"] = "BROKERAGE";
  ProductDistributionModeEnum2["SERVICE"] = "SERVICE";
  ProductDistributionModeEnum2["TECHNICAL_ENABLING"] = "TECHNICAL_ENABLING";
  return ProductDistributionModeEnum2;
}({});
var ProductTargetEnum = /* @__PURE__ */ function(ProductTargetEnum2) {
  ProductTargetEnum2["FLIGHT_TO_JOURNEY"] = "FLIGHT_TO_JOURNEY";
  ProductTargetEnum2["JOURNEY"] = "JOURNEY";
  ProductTargetEnum2["TRIP"] = "TRIP";
  return ProductTargetEnum2;
}({});
var ProductAttachmentTypeEnum = /* @__PURE__ */ function(ProductAttachmentTypeEnum2) {
  ProductAttachmentTypeEnum2["CERTIFICATE_OF_MEMBERSHIP"] = "CERTIFICATE_OF_MEMBERSHIP";
  ProductAttachmentTypeEnum2["HOW_TO"] = "HOW_TO";
  ProductAttachmentTypeEnum2["TERMS_AND_CONDITIONS"] = "TERMS_AND_CONDITIONS";
  return ProductAttachmentTypeEnum2;
}({});
var CoveredEventTypeEnum = /* @__PURE__ */ function(CoveredEventTypeEnum2) {
  CoveredEventTypeEnum2["FLIGHT"] = "FLIGHT";
  CoveredEventTypeEnum2["TRIP"] = "TRIP";
  CoveredEventTypeEnum2["STAY"] = "STAY";
  return CoveredEventTypeEnum2;
}({});
var ClaimEligibilityConditionNames = {
  HAS_BAGGAGE_BEEN_DISRUPTED: "HAS_BAGGAGE_BEEN_DISRUPTED",
  HAS_CANCELLATION_PROOF_DOCUMENT: "HAS_CANCELLATION_PROOF_DOCUMENT",
  HAS_FLIGHT_BEEN_CANCELED: "HAS_FLIGHT_BEEN_CANCELED",
  HAS_FLIGHT_BEEN_DELAYED: "HAS_FLIGHT_BEEN_DELAYED",
  HAS_FLIGHT_BEEN_DISRUPTED: "HAS_FLIGHT_BEEN_DISRUPTED",
  HAS_FLIGHT_BEEN_DIVERTED: "HAS_FLIGHT_BEEN_DIVERTED",
  HAS_INSUFFICIENT_CONNECTING_TIME: "HAS_INSUFFICIENT_CONNECTING_TIME",
  HAS_JOURNEY_BEEN_DISRUPTED: "HAS_JOURNEY_BEEN_DISRUPTED",
  HAS_MISSED_CONNECTION: "HAS_MISSED_CONNECTION",
  HAS_NON_FINAL_CANCELED_FLIGHT: "HAS_NON_FINAL_CANCELED_FLIGHT",
  HAS_NON_FINAL_DIVERTED_FLIGHT: "HAS_NON_FINAL_DIVERTED_FLIGHT",
  HAS_TRIP_HAS_NO_CANCELED_FLIGHT: "HAS_TRIP_HAS_NO_CANCELED_FLIGHT",
  HAS_VALID_CLAIM_DEADLINE: "HAS_VALID_CLAIM_DEADLINE",
  IS_CLAIMABLE: "IS_CLAIMABLE",
  IS_CONTRACT_ACTIVE: "IS_CONTRACT_ACTIVE",
  ARE_BAGGAGE_DISRUPTIONS_COVERED: "ARE_BAGGAGE_DISRUPTIONS_COVERED",
  ARE_DISRUPTED_BAGGAGE_MATCHING_CHECKED_BAGGAGE: "ARE_DISRUPTED_BAGGAGE_MATCHING_CHECKED_BAGGAGE",
  IS_CLAIM_TOO_EARLY: "IS_CLAIM_TOO_EARLY",
  IS_NOT_EASYJET_PORTUGAL_STRIKE_CLAIM: "IS_NOT_EASYJET_PORTUGAL_STRIKE_CLAIM",
  IS_NOT_OMIO_CLAIM_WITH_VUELING_FLIGHT: "IS_NOT_OMIO_CLAIM_WITH_VUELING_FLIGHT"
};
var ClaimTriggers = {
  AUTOMATIC: "AUTOMATIC",
  MANUAL: "MANUAL"
};
var FraudProductConditionNameEnum = /* @__PURE__ */ function(FraudProductConditionNameEnum2) {
  FraudProductConditionNameEnum2["HAS_ACCEPTABLE_CLAIMING_PERIOD"] = "HAS_ACCEPTABLE_CLAIMING_PERIOD";
  FraudProductConditionNameEnum2["HAS_COHERENT_NAMES"] = "HAS_COHERENT_NAMES";
  FraudProductConditionNameEnum2["HAS_NO_SIMILAR_BANK_DETAILS_WITH_DIFFERENT_CUSTOMER"] = "HAS_NO_SIMILAR_BANK_DETAILS_WITH_DIFFERENT_CUSTOMER";
  FraudProductConditionNameEnum2["HAS_NON_EUROPEAN_IBAN"] = "HAS_NON_EUROPEAN_IBAN";
  FraudProductConditionNameEnum2["HAS_SUSPICIOUS_AIRLINE"] = "HAS_SUSPICIOUS_AIRLINE";
  FraudProductConditionNameEnum2["HAS_UNEXPECTED_PARTNER_BANK_DETAILS"] = "HAS_UNEXPECTED_PARTNER_BANK_DETAILS";
  FraudProductConditionNameEnum2["HAVE_DOCUMENTS_BEEN_APPROVED"] = "HAVE_DOCUMENTS_BEEN_APPROVED";
  return FraudProductConditionNameEnum2;
}({});
var OtherProductConditionNameEnum = /* @__PURE__ */ function(OtherProductConditionNameEnum2) {
  OtherProductConditionNameEnum2["BANK_DETAIL_NOT_HANDLED"] = "BANK_DETAIL_NOT_HANDLED";
  OtherProductConditionNameEnum2["HAS_BANK_DETAIL"] = "HAS_BANK_DETAIL";
  OtherProductConditionNameEnum2["BANK_DETAILS_NOT_NEEDED"] = "BANK_DETAILS_NOT_NEEDED";
  OtherProductConditionNameEnum2["NO_CONDITIONS_CONFIGURED"] = "NO_CONDITIONS_CONFIGURED";
  OtherProductConditionNameEnum2["REJECTED_MANUALLY"] = "REJECTED_MANUALLY";
  OtherProductConditionNameEnum2["IS_GOODWILL_GESTURE"] = "IS_GOODWILL_GESTURE";
  return OtherProductConditionNameEnum2;
}({});
var ProductCompensationSettingPropertyEnum = /* @__PURE__ */ function(ProductCompensationSettingPropertyEnum2) {
  ProductCompensationSettingPropertyEnum2["TARGET_PRICE"] = "TARGET_PRICE";
  ProductCompensationSettingPropertyEnum2["CANCELLATION_FEES"] = "CANCELLATION_FEES";
  ProductCompensationSettingPropertyEnum2["NON_REFUNDABLE_TRIP_PRICE"] = "NON_REFUNDABLE_TRIP_PRICE";
  return ProductCompensationSettingPropertyEnum2;
}({});
var PriceSettingTypeEnum = /* @__PURE__ */ function(PriceSettingTypeEnum2) {
  PriceSettingTypeEnum2["COEFFICIENT"] = "COEFFICIENT";
  PriceSettingTypeEnum2["FIXED"] = "FIXED";
  return PriceSettingTypeEnum2;
}({});
var ExtendedPriceSettingTypeEnum = {
  ...PriceSettingTypeEnum,
  COEFFICIENT_AND_FIXED: "COEFFICIENT_AND_FIXED"
};
var ProductPricingProviderEnum = /* @__PURE__ */ function(ProductPricingProviderEnum2) {
  ProductPricingProviderEnum2["KOALA"] = "KOALA";
  ProductPricingProviderEnum2["SWISS_RE"] = "SWISS_RE";
  ProductPricingProviderEnum2["WAKAM"] = "WAKAM";
  ProductPricingProviderEnum2["CARTRAWLER"] = "CARTRAWLER";
  return ProductPricingProviderEnum2;
}({});
var ProductPricingSettingCoefficientPropertyEnum = /* @__PURE__ */ function(ProductPricingSettingCoefficientPropertyEnum2) {
  ProductPricingSettingCoefficientPropertyEnum2["COMPENSATION_AMOUNT"] = "COMPENSATION_AMOUNT";
  ProductPricingSettingCoefficientPropertyEnum2["FLIGHT_PRICE"] = "FLIGHT_PRICE";
  ProductPricingSettingCoefficientPropertyEnum2["NON_REFUNDABLE_TRIP_PRICE"] = "NON_REFUNDABLE_TRIP_PRICE";
  ProductPricingSettingCoefficientPropertyEnum2["TRIP_DURATION"] = "TRIP_DURATION";
  ProductPricingSettingCoefficientPropertyEnum2["TRIP_PRICE"] = "TRIP_PRICE";
  return ProductPricingSettingCoefficientPropertyEnum2;
}({});
var ProductCommissionSettingCoefficientPropertyEnum = /* @__PURE__ */ function(ProductCommissionSettingCoefficientPropertyEnum2) {
  ProductCommissionSettingCoefficientPropertyEnum2["GROSS_NET_WRITTEN_PREMIUM"] = "GROSS_NET_WRITTEN_PREMIUM";
  ProductCommissionSettingCoefficientPropertyEnum2["NON_REFUNDABLE_TRIP_PRICE"] = "NON_REFUNDABLE_TRIP_PRICE";
  ProductCommissionSettingCoefficientPropertyEnum2["TRIP_PRICE"] = "TRIP_PRICE";
  return ProductCommissionSettingCoefficientPropertyEnum2;
}({});
var ProductProviderEnum = /* @__PURE__ */ function(ProductProviderEnum2) {
  ProductProviderEnum2["AVA"] = "AVA";
  ProductProviderEnum2["WAKAM"] = "WAKAM";
  ProductProviderEnum2["KOALA"] = "KOALA";
  ProductProviderEnum2["SEYNA"] = "SEYNA";
  ProductProviderEnum2["AXERIA"] = "AXERIA";
  ProductProviderEnum2["MEETCH"] = "MEETCH";
  ProductProviderEnum2["EIR"] = "EIR";
  ProductProviderEnum2["BATTLEFACE"] = "BATTLEFACE";
  return ProductProviderEnum2;
}({});
var ProductCommissionSettingsBeneficiariesEnum = /* @__PURE__ */ function(ProductCommissionSettingsBeneficiariesEnum2) {
  ProductCommissionSettingsBeneficiariesEnum2["INSURER"] = "INSURER";
  ProductCommissionSettingsBeneficiariesEnum2["KOALA"] = "KOALA";
  ProductCommissionSettingsBeneficiariesEnum2["PARTNER"] = "PARTNER";
  return ProductCommissionSettingsBeneficiariesEnum2;
}({});
var BusinessContributorEnum = /* @__PURE__ */ function(BusinessContributorEnum2) {
  BusinessContributorEnum2["HEPSTAR"] = "HEPSTAR";
  return BusinessContributorEnum2;
}({});

// src/product/commission-settings.ts
var ANY_COVERED_EVENT_COMMISSION_PROPERTIES = [
  ProductCommissionSettingCoefficientPropertyEnum.GROSS_NET_WRITTEN_PREMIUM,
  ProductCommissionSettingCoefficientPropertyEnum.TRIP_PRICE
];
var ALLOWED_COMMISSION_COEFFICIENT_PROPERTIES_PER_COVERED_EVENT = {
  [CoveredEventTypeEnum.TRIP]: [
    ...ANY_COVERED_EVENT_COMMISSION_PROPERTIES,
    ProductCommissionSettingCoefficientPropertyEnum.NON_REFUNDABLE_TRIP_PRICE
  ],
  [CoveredEventTypeEnum.FLIGHT]: ANY_COVERED_EVENT_COMMISSION_PROPERTIES,
  [CoveredEventTypeEnum.STAY]: ANY_COVERED_EVENT_COMMISSION_PROPERTIES
};
function isCommissionCoefficientPropertyAllowedForCoveredEvent(coveredEventType, coefficientProperty) {
  return ALLOWED_COMMISSION_COEFFICIENT_PROPERTIES_PER_COVERED_EVENT[coveredEventType].includes(coefficientProperty);
}
__name(isCommissionCoefficientPropertyAllowedForCoveredEvent, "isCommissionCoefficientPropertyAllowedForCoveredEvent");

// src/product/compensation-settings.ts
var COMMON_COMPENSATION_PROPERTIES = [
  ProductCompensationSettingPropertyEnum.TARGET_PRICE,
  ProductCompensationSettingPropertyEnum.CANCELLATION_FEES
];
var ALLOWED_COMPENSATION_PROPERTIES = {
  [ProductTypeEnum.COMPREHENSIVE]: COMMON_COMPENSATION_PROPERTIES,
  [ProductTypeEnum.FLIGHT_DISRUPTION]: COMMON_COMPENSATION_PROPERTIES,
  [ProductTypeEnum.WITHDRAWAL]: [
    ...COMMON_COMPENSATION_PROPERTIES,
    ProductCompensationSettingPropertyEnum.NON_REFUNDABLE_TRIP_PRICE
  ],
  [ProductTypeEnum.CHANGE_FOR_ANY_REASON]: COMMON_COMPENSATION_PROPERTIES,
  [ProductTypeEnum.CANCELLATION_WITHOUT_PROOF]: COMMON_COMPENSATION_PROPERTIES,
  [ProductTypeEnum.BAGGAGE_DISRUPTION]: COMMON_COMPENSATION_PROPERTIES
};
function isCompensationPropertyAllowed(productType, coefficientProperty) {
  return ALLOWED_COMPENSATION_PROPERTIES[productType].includes(coefficientProperty);
}
__name(isCompensationPropertyAllowed, "isCompensationPropertyAllowed");
function isCoefficientCompensationSettings(compensationSettings) {
  return compensationSettings.type === PriceSettingTypeEnum.COEFFICIENT;
}
__name(isCoefficientCompensationSettings, "isCoefficientCompensationSettings");

// src/product/currencies.ts
var CURRENCIES = [
  "AED",
  "AFN",
  "ALL",
  "ANG",
  "ARS",
  "AUD",
  "AWG",
  "AZN",
  "BAM",
  "BBD",
  "BGN",
  "BMD",
  "BND",
  "BOB",
  "BRL",
  "BSD",
  "BWP",
  "BYR",
  "BZD",
  "CAD",
  "CHF",
  "CLP",
  "CNY",
  "COP",
  "CRC",
  "CUP",
  "CZK",
  "DKK",
  "DOP",
  "DZD",
  "EGP",
  "EUR",
  "FJD",
  "FKP",
  "GBP",
  "GGP",
  "GHC",
  "GIP",
  "GTQ",
  "GYD",
  "HKD",
  "HNL",
  "HRK",
  "HUF",
  "IDR",
  "ILS",
  "IMP",
  "INR",
  "IRR",
  "ISK",
  "JEP",
  "JMD",
  "JPY",
  "KGS",
  "KHR",
  "KPW",
  "KRW",
  "KYD",
  "KZT",
  "LAK",
  "LBP",
  "LKR",
  "LRD",
  "LTL",
  "LVL",
  "MAD",
  "MKD",
  "MNT",
  "MUR",
  "MXN",
  "MYR",
  "MZN",
  "NAD",
  "NGN",
  "NIO",
  "NOK",
  "NPR",
  "NZD",
  "OMR",
  "PAB",
  "PEN",
  "PHP",
  "PKR",
  "PLN",
  "PYG",
  "QAR",
  "RON",
  "RSD",
  "RUB",
  "SAR",
  "SBD",
  "SCR",
  "SEK",
  "SGD",
  "SHP",
  "SOS",
  "SRD",
  "SVC",
  "SYP",
  "THB",
  "TND",
  "TRL",
  "TRY",
  "TTD",
  "TVD",
  "TWD",
  "UAH",
  "USD",
  "UYU",
  "UZS",
  "VEF",
  "VND",
  "XCD",
  "YER",
  "ZAR",
  "ZWD"
];

// src/product/cwp-cancellation-reasons.ts
var CwpCancellationReasons = {
  PERSONAL_REASONS: "PERSONAL_REASONS",
  OTHER: "OTHER"
};

// src/product/languages.ts
var STANDARD_LANGUAGES = [
  "aa",
  "aa-DJ",
  "aa-ER",
  "aa-ET",
  "af",
  "af-NA",
  "af-ZA",
  "agq",
  "agq-CM",
  "ak",
  "ak-GH",
  "sq",
  "sq-AL",
  "sq-MK",
  "gsw",
  "gsw-FR",
  "gsw-LI",
  "gsw-CH",
  "am",
  "am-ET",
  "ar",
  "ar-DZ",
  "ar-BH",
  "ar-TD",
  "ar-KM",
  "ar-DJ",
  "ar-EG",
  "ar-ER",
  "ar-IQ",
  "ar-IL",
  "ar-JO",
  "ar-KW",
  "ar-LB",
  "ar-LY",
  "ar-MR",
  "ar-MA",
  "ar-OM",
  "ar-PS",
  "ar-QA",
  "ar-SA",
  "ar-SO",
  "ar-SS",
  "ar-SD",
  "ar-SY",
  "ar-TN",
  "ar-AE",
  "ar-001",
  "ar-YE",
  "hy",
  "hy-AM",
  "as",
  "as-IN",
  "ast",
  "ast-ES",
  "asa",
  "asa-TZ",
  "az-Cyrl",
  "az-Cyrl-AZ",
  "az",
  "az-Latn",
  "az-Latn-AZ",
  "ksf",
  "ksf-CM",
  "bm",
  "bm-Latn-ML",
  "bn",
  "bn-BD",
  "bn-IN",
  "bas",
  "bas-CM",
  "ba",
  "ba-RU",
  "eu",
  "eu-ES",
  "be",
  "be-BY",
  "bem",
  "bem-ZM",
  "bez",
  "bez-TZ",
  "byn",
  "byn-ER",
  "brx",
  "brx-IN",
  "bs-Cyrl",
  "bs-Cyrl-BA",
  "bs-Latn",
  "bs",
  "bs-Latn-BA",
  "br",
  "br-FR",
  "bg",
  "bg-BG",
  "my",
  "my-MM",
  "ca",
  "ca-AD",
  "ca-FR",
  "ca-IT",
  "ca-ES",
  "ceb",
  "ceb-Latn",
  "ceb-Latn-PH",
  "tzm-Latn-",
  "ku",
  "ku-Arab",
  "ku-Arab-IQ",
  "ccp",
  "ccp-Cakm",
  "ccp-Cakm-",
  "cd-RU",
  "chr",
  "chr-Cher",
  "chr-Cher-US",
  "cgg",
  "cgg-UG",
  "zh-Hans",
  "zh",
  "zh-CN",
  "zh-SG",
  "zh-Hant",
  "zh-HK",
  "zh-MO",
  "zh-TW",
  "cu-RU",
  "swc",
  "swc-CD",
  "kw",
  "kw-GB",
  "co",
  "co-FR",
  "hr",
  "hr-HR",
  "hr-BA",
  "cs",
  "cs-CZ",
  "da",
  "da-DK",
  "da-GL",
  "prs",
  "prs-AF",
  "dv",
  "dv-MV",
  "dua",
  "dua-CM",
  "nl",
  "nl-AW",
  "nl-BE",
  "nl-BQ",
  "nl-CW",
  "nl-NL",
  "nl-SX",
  "nl-SR",
  "dz",
  "dz-BT",
  "ebu",
  "ebu-KE",
  "en",
  "en-AS",
  "en-AI",
  "en-AG",
  "en-AU",
  "en-AT",
  "en-BS",
  "en-BB",
  "en-BE",
  "en-BZ",
  "en-BM",
  "en-BW",
  "en-IO",
  "en-VG",
  "en-BI",
  "en-CM",
  "en-CA",
  "en-029",
  "en-KY",
  "en-CX",
  "en-CC",
  "en-CK",
  "en-CY",
  "en-DK",
  "en-DM",
  "en-ER",
  "en-150",
  "en-FK",
  "en-FI",
  "en-FJ",
  "en-GM",
  "en-DE",
  "en-GH",
  "en-GI",
  "en-GD",
  "en-GU",
  "en-GG",
  "en-GY",
  "en-HK",
  "en-IN",
  "en-IE",
  "en-IM",
  "en-IL",
  "en-JM",
  "en-JE",
  "en-KE",
  "en-KI",
  "en-LS",
  "en-LR",
  "en-MO",
  "en-MG",
  "en-MW",
  "en-MY",
  "en-MT",
  "en-MH",
  "en-MU",
  "en-FM",
  "en-MS",
  "en-NA",
  "en-NR",
  "en-NL",
  "en-NZ",
  "en-NG",
  "en-NU",
  "en-NF",
  "en-MP",
  "en-PK",
  "en-PW",
  "en-PG",
  "en-PN",
  "en-PR",
  "en-PH",
  "en-RW",
  "en-KN",
  "en-LC",
  "en-VC",
  "en-WS",
  "en-SC",
  "en-SL",
  "en-SG",
  "en-SX",
  "en-SI",
  "en-SB",
  "en-ZA",
  "en-SS",
  "en-SH",
  "en-SD",
  "en-SZ",
  "en-SE",
  "en-CH",
  "en-TZ",
  "en-TK",
  "en-TO",
  "en-TT",
  "en-TC",
  "en-TV",
  "en-UG",
  "en-AE",
  "en-GB",
  "en-US",
  "en-UM",
  "en-VI",
  "en-VU",
  "en-001",
  "en-ZM",
  "en-ZW",
  "eo",
  "eo-001",
  "et",
  "et-EE",
  "ee",
  "ee-GH",
  "ee-TG",
  "ewo",
  "ewo-CM",
  "fo",
  "fo-DK",
  "fo-FO",
  "fil",
  "fil-PH",
  "fi",
  "fi-FI",
  "fr",
  "fr-DZ",
  "fr-BE",
  "fr-BJ",
  "fr-BF",
  "fr-BI",
  "fr-CM",
  "fr-CA",
  "fr-CF",
  "fr-TD",
  "fr-KM",
  "fr-CG",
  "fr-CD",
  "fr-CI",
  "fr-DJ",
  "fr-GQ",
  "fr-FR",
  "fr-GF",
  "fr-PF",
  "fr-GA",
  "fr-GP",
  "fr-GN",
  "fr-HT",
  "fr-LU",
  "fr-MG",
  "fr-ML",
  "fr-MQ",
  "fr-MR",
  "fr-MU",
  "fr-YT",
  "fr-MA",
  "fr-NC",
  "fr-NE",
  "fr-MC",
  "fr-RE",
  "fr-RW",
  "fr-BL",
  "fr-MF",
  "fr-PM",
  "fr-SN",
  "fr-SC",
  "fr-CH",
  "fr-SY",
  "fr-TG",
  "fr-TN",
  "fr-VU",
  "fr-WF",
  "fy",
  "fy-NL",
  "fur",
  "fur-IT",
  "ff",
  "ff-Latn",
  "ff-Latn-BF",
  "ff-CM",
  "ff-Latn-CM",
  "ff-Latn-GM",
  "ff-Latn-GH",
  "ff-GN",
  "ff-Latn-GN",
  "ff-Latn-GW",
  "ff-Latn-LR",
  "ff-MR",
  "ff-Latn-MR",
  "ff-Latn-NE",
  "ff-NG",
  "ff-Latn-NG",
  "ff-Latn-SN",
  "ff-Latn-SL",
  "gl",
  "gl-ES",
  "lg",
  "lg-UG",
  "ka",
  "ka-GE",
  "de",
  "de-AT",
  "de-BE",
  "de-DE",
  "de-IT",
  "de-LI",
  "de-LU",
  "de-CH",
  "el",
  "el-CY",
  "el-GR",
  "kl",
  "kl-GL",
  "gn",
  "gn-PY",
  "gu",
  "gu-IN",
  "guz",
  "guz-KE",
  "ha",
  "ha-Latn",
  "ha-Latn-GH",
  "ha-Latn-NE",
  "ha-Latn-NG",
  "haw",
  "haw-US",
  "he",
  "he-IL",
  "hi",
  "hi-IN",
  "hu",
  "hu-HU",
  "is",
  "is-IS",
  "ig",
  "ig-NG",
  "id",
  "id-ID",
  "ia",
  "ia-FR",
  "ia-001",
  "iu",
  "iu-Latn",
  "iu-Latn-CA",
  "iu-Cans",
  "iu-Cans-CA",
  "ga",
  "ga-IE",
  "it",
  "it-IT",
  "it-SM",
  "it-CH",
  "it-VA",
  "ja",
  "ja-JP",
  "jv",
  "jv-Latn",
  "jv-Latn-ID",
  "dyo",
  "dyo-SN",
  "kea",
  "kea-CV",
  "kab",
  "kab-DZ",
  "kkj",
  "kkj-CM",
  "kln",
  "kln-KE",
  "kam",
  "kam-KE",
  "kn",
  "kn-IN",
  "ks",
  "ks-Arab",
  "ks-Arab-IN",
  "kk",
  "kk-KZ",
  "km",
  "km-KH",
  "quc",
  "quc-Latn-GT",
  "ki",
  "ki-KE",
  "rw",
  "rw-RW",
  "sw",
  "sw-KE",
  "sw-TZ",
  "sw-UG",
  "kok",
  "kok-IN",
  "ko",
  "ko-KR",
  "ko-KP",
  "khq",
  "khq-ML",
  "ses",
  "ses-ML",
  "nmg",
  "nmg-CM",
  "ky",
  "ky-KG",
  "ku-Arab-IR",
  "lkt",
  "lkt-US",
  "lag",
  "lag-TZ",
  "lo",
  "lo-LA",
  "lv",
  "lv-LV",
  "ln",
  "ln-AO",
  "ln-CF",
  "ln-CG",
  "ln-CD",
  "lt",
  "lt-LT",
  "nds",
  "nds-DE",
  "nds-NL",
  "dsb",
  "dsb-DE",
  "lu",
  "lu-CD",
  "luo",
  "luo-KE",
  "lb",
  "lb-LU",
  "luy",
  "luy-KE",
  "mk",
  "mk-MK",
  "jmc",
  "jmc-TZ",
  "mgh",
  "mgh-MZ",
  "kde",
  "kde-TZ",
  "mg",
  "mg-MG",
  "ms",
  "ms-BN",
  "ms-MY",
  "ml",
  "ml-IN",
  "mt",
  "mt-MT",
  "gv",
  "gv-IM",
  "mi",
  "mi-NZ",
  "arn",
  "arn-CL",
  "mr",
  "mr-IN",
  "mas",
  "mas-KE",
  "mas-TZ",
  "mzn-IR",
  "mer",
  "mer-KE",
  "mgo",
  "mgo-CM",
  "moh",
  "moh-CA",
  "mn",
  "mn-Cyrl",
  "mn-MN",
  "mn-Mong",
  "mn-Mong-CN",
  "mn-Mong-MN",
  "mfe",
  "mfe-MU",
  "mua",
  "mua-CM",
  "nqo",
  "nqo-GN",
  "naq",
  "naq-NA",
  "ne",
  "ne-IN",
  "ne-NP",
  "nnh",
  "nnh-CM",
  "jgo",
  "jgo-CM",
  "lrc-IQ",
  "lrc-IR",
  "nd",
  "nd-ZW",
  "no",
  "nb",
  "nb-NO",
  "nn",
  "nn-NO",
  "nb-SJ",
  "nus",
  "nus-SD",
  "nus-SS",
  "nyn",
  "nyn-UG",
  "oc",
  "oc-FR",
  "or",
  "or-IN",
  "om",
  "om-ET",
  "om-KE",
  "os",
  "os-GE",
  "os-RU",
  "ps",
  "ps-AF",
  "ps-PK",
  "fa",
  "fa-AF",
  "fa-IR",
  "pl",
  "pl-PL",
  "pt",
  "pt-AO",
  "pt-BR",
  "pt-CV",
  "pt-GQ",
  "pt-GW",
  "pt-LU",
  "pt-MO",
  "pt-MZ",
  "pt-PT",
  "pt-ST",
  "pt-CH",
  "pt-TL",
  "prg-001",
  "qps-ploca",
  "qps-ploc",
  "qps-plocm",
  "pa",
  "pa-Arab",
  "pa-IN",
  "pa-Arab-PK",
  "quz",
  "quz-BO",
  "quz-EC",
  "quz-PE",
  "ksh",
  "ksh-DE",
  "ro",
  "ro-MD",
  "ro-RO",
  "rm",
  "rm-CH",
  "rof",
  "rof-TZ",
  "rn",
  "rn-BI",
  "ru",
  "ru-BY",
  "ru-KZ",
  "ru-KG",
  "ru-MD",
  "ru-RU",
  "ru-UA",
  "rwk",
  "rwk-TZ",
  "ssy",
  "ssy-ER",
  "sah",
  "sah-RU",
  "saq",
  "saq-KE",
  "smn",
  "smn-FI",
  "smj",
  "smj-NO",
  "smj-SE",
  "se",
  "se-FI",
  "se-NO",
  "se-SE",
  "sms",
  "sms-FI",
  "sma",
  "sma-NO",
  "sma-SE",
  "sg",
  "sg-CF",
  "sbp",
  "sbp-TZ",
  "sa",
  "sa-IN",
  "gd",
  "gd-GB",
  "seh",
  "seh-MZ",
  "sr-Cyrl",
  "sr-Cyrl-BA",
  "sr-Cyrl-ME",
  "sr-Cyrl-RS",
  "sr-Cyrl-CS",
  "sr-Latn",
  "sr",
  "sr-Latn-BA",
  "sr-Latn-ME",
  "sr-Latn-RS",
  "sr-Latn-CS",
  "nso",
  "nso-ZA",
  "tn",
  "tn-BW",
  "tn-ZA",
  "ksb",
  "ksb-TZ",
  "sn",
  "sn-Latn",
  "sn-Latn-ZW",
  "sd",
  "sd-Arab",
  "sd-Arab-PK",
  "si",
  "si-LK",
  "sk",
  "sk-SK",
  "sl",
  "sl-SI",
  "xog",
  "xog-UG",
  "so",
  "so-DJ",
  "so-ET",
  "so-KE",
  "so-SO",
  "st",
  "st-ZA",
  "nr",
  "nr-ZA",
  "st-LS",
  "es",
  "es-AR",
  "es-BZ",
  "es-VE",
  "es-BO",
  "es-BR",
  "es-CL",
  "es-CO",
  "es-CR",
  "es-CU",
  "es-DO",
  "es-EC",
  "es-SV",
  "es-GQ",
  "es-GT",
  "es-HN",
  "es-419",
  "es-MX",
  "es-NI",
  "es-PA",
  "es-PY",
  "es-PE",
  "es-PH",
  "es-PR",
  "es-ES_tradnl",
  "es-ES",
  "es-US",
  "es-UY",
  "zgh",
  "zgh-Tfng-MA",
  "zgh-Tfng",
  "ss",
  "ss-ZA",
  "ss-SZ",
  "sv",
  "sv-AX",
  "sv-FI",
  "sv-SE",
  "syr",
  "syr-SY",
  "shi",
  "shi-Tfng",
  "shi-Tfng-MA",
  "shi-Latn",
  "shi-Latn-MA",
  "dav",
  "dav-KE",
  "tg",
  "tg-Cyrl",
  "tg-Cyrl-TJ",
  "tzm",
  "tzm-Latn",
  "tzm-Latn-DZ",
  "ta",
  "ta-IN",
  "ta-MY",
  "ta-SG",
  "ta-LK",
  "twq",
  "twq-NE",
  "tt",
  "tt-RU",
  "te",
  "te-IN",
  "teo",
  "teo-KE",
  "teo-UG",
  "th",
  "th-TH",
  "bo",
  "bo-IN",
  "bo-CN",
  "tig",
  "tig-ER",
  "ti",
  "ti-ER",
  "ti-ET",
  "to",
  "to-TO",
  "ts",
  "ts-ZA",
  "tr",
  "tr-CY",
  "tr-TR",
  "tk",
  "tk-TM",
  "uk",
  "uk-UA",
  "hsb",
  "hsb-DE",
  "ur",
  "ur-IN",
  "ur-PK",
  "ug",
  "ug-CN",
  "uz-Arab",
  "uz-Arab-AF",
  "uz-Cyrl",
  "uz-Cyrl-UZ",
  "uz",
  "uz-Latn",
  "uz-Latn-UZ",
  "vai",
  "vai-Vaii",
  "vai-Vaii-LR",
  "vai-Latn-LR",
  "vai-Latn",
  "ca-ES-",
  "ve",
  "ve-ZA",
  "vi",
  "vi-VN",
  "vo",
  "vo-001",
  "vun",
  "vun-TZ",
  "wae",
  "wae-CH",
  "cy",
  "cy-GB",
  "wal",
  "wal-ET",
  "wo",
  "wo-SN",
  "xh",
  "xh-ZA",
  "yav",
  "yav-CM",
  "ii",
  "ii-CN",
  "yo",
  "yo-BJ",
  "yo-NG",
  "dje",
  "dje-NE",
  "zu",
  "zu-ZA"
];
var NON_STANDARD_LANGUAGES = [
  // FIXME: The non standard languages in this array do not match the ISO we chose to replicate. However, some product were manually created with them. The database must be cleaned before this array can be removed.
  "es",
  "pl",
  "sk",
  "sv",
  "nl",
  "cs",
  "cs-cz",
  "hu",
  "da",
  "fr-FR",
  "no",
  "fi",
  "mk",
  "fr-CH"
];
var LANGUAGES = [
  ...STANDARD_LANGUAGES,
  ...NON_STANDARD_LANGUAGES
];

// src/product/meetch-product-type.ts
var MeetchProductType = {
  COVER: "Cover",
  TRAVEL: "Travel",
  TRAVEL_PER_TRAVELER_PER_DAY: "TravelPerTravelerPerDay"
};

// src/product/pricing-settings.ts
var ANY_PRICE_COEFFICIENT_PROPERTIES = [
  ProductPricingSettingCoefficientPropertyEnum.COMPENSATION_AMOUNT,
  ProductPricingSettingCoefficientPropertyEnum.FLIGHT_PRICE,
  ProductPricingSettingCoefficientPropertyEnum.TRIP_DURATION,
  ProductPricingSettingCoefficientPropertyEnum.TRIP_PRICE
];
var ALLOWED_PRICING_COEFFICIENT_PROPERTIES = {
  [ProductTypeEnum.COMPREHENSIVE]: ANY_PRICE_COEFFICIENT_PROPERTIES,
  [ProductTypeEnum.FLIGHT_DISRUPTION]: ANY_PRICE_COEFFICIENT_PROPERTIES,
  [ProductTypeEnum.WITHDRAWAL]: [
    ProductPricingSettingCoefficientPropertyEnum.COMPENSATION_AMOUNT,
    ProductPricingSettingCoefficientPropertyEnum.NON_REFUNDABLE_TRIP_PRICE,
    ProductPricingSettingCoefficientPropertyEnum.TRIP_PRICE
  ],
  [ProductTypeEnum.CHANGE_FOR_ANY_REASON]: ANY_PRICE_COEFFICIENT_PROPERTIES,
  [ProductTypeEnum.CANCELLATION_WITHOUT_PROOF]: ANY_PRICE_COEFFICIENT_PROPERTIES,
  [ProductTypeEnum.BAGGAGE_DISRUPTION]: ANY_PRICE_COEFFICIENT_PROPERTIES
};
function isPricingCoefficientPropertyAllowed(productType, coefficientProperty) {
  return ALLOWED_PRICING_COEFFICIENT_PROPERTIES[productType].includes(coefficientProperty);
}
__name(isPricingCoefficientPropertyAllowed, "isPricingCoefficientPropertyAllowed");
var ALLOWED_PRICING_COEFFICIENT_PROPERTIES_PER_COVERED_EVENT = {
  [CoveredEventTypeEnum.TRIP]: [
    ProductPricingSettingCoefficientPropertyEnum.COMPENSATION_AMOUNT,
    ProductPricingSettingCoefficientPropertyEnum.NON_REFUNDABLE_TRIP_PRICE,
    ProductPricingSettingCoefficientPropertyEnum.TRIP_DURATION,
    ProductPricingSettingCoefficientPropertyEnum.TRIP_PRICE
  ],
  [CoveredEventTypeEnum.FLIGHT]: [
    ProductPricingSettingCoefficientPropertyEnum.COMPENSATION_AMOUNT,
    ProductPricingSettingCoefficientPropertyEnum.FLIGHT_PRICE,
    ProductPricingSettingCoefficientPropertyEnum.TRIP_PRICE
  ],
  [CoveredEventTypeEnum.STAY]: [
    ProductPricingSettingCoefficientPropertyEnum.COMPENSATION_AMOUNT,
    ProductPricingSettingCoefficientPropertyEnum.TRIP_PRICE
  ]
};
function isPricingCoefficientPropertyAllowedForCoveredEvent(coveredEventType, coefficientProperty) {
  return ALLOWED_PRICING_COEFFICIENT_PROPERTIES_PER_COVERED_EVENT[coveredEventType].includes(coefficientProperty);
}
__name(isPricingCoefficientPropertyAllowedForCoveredEvent, "isPricingCoefficientPropertyAllowedForCoveredEvent");
var WITHDRAWAL_ALLOWED_COEFFICIENT_PROPERTIES = ALLOWED_PRICING_COEFFICIENT_PROPERTIES[ProductTypeEnum.WITHDRAWAL];
function isCoefficientPricingSetting(pricingSettings) {
  return pricingSettings.type === PriceSettingTypeEnum.COEFFICIENT;
}
__name(isCoefficientPricingSetting, "isCoefficientPricingSetting");

// src/product/product.ts
function isProductWithClaimSettings(product) {
  const HAS_CLAIM_SETTINGS_MAPPING = {
    [ProductTypeEnum.WITHDRAWAL]: true,
    [ProductTypeEnum.FLIGHT_DISRUPTION]: true,
    [ProductTypeEnum.CHANGE_FOR_ANY_REASON]: true,
    [ProductTypeEnum.CANCELLATION_WITHOUT_PROOF]: true,
    [ProductTypeEnum.BAGGAGE_DISRUPTION]: true,
    [ProductTypeEnum.COMPREHENSIVE]: false
  };
  return HAS_CLAIM_SETTINGS_MAPPING[product.type];
}
__name(isProductWithClaimSettings, "isProductWithClaimSettings");

// src/product/product-claimability.ts
var PRODUCT_CLAIMABLE_BY_CUSTOMER = {
  [ProductTypeEnum.WITHDRAWAL]: true,
  [ProductTypeEnum.FLIGHT_DISRUPTION]: true,
  [ProductTypeEnum.BAGGAGE_DISRUPTION]: true,
  [ProductTypeEnum.CANCELLATION_WITHOUT_PROOF]: true,
  [ProductTypeEnum.CHANGE_FOR_ANY_REASON]: false,
  [ProductTypeEnum.COMPREHENSIVE]: false
};
var PRODUCT_CLAIMABLE_BY_PARTNER = {
  [ProductTypeEnum.WITHDRAWAL]: true,
  [ProductTypeEnum.CHANGE_FOR_ANY_REASON]: true,
  [ProductTypeEnum.FLIGHT_DISRUPTION]: true,
  [ProductTypeEnum.CANCELLATION_WITHOUT_PROOF]: false,
  [ProductTypeEnum.COMPREHENSIVE]: false,
  [ProductTypeEnum.BAGGAGE_DISRUPTION]: false
};
function isProductClaimableByCustomer(productType) {
  return PRODUCT_CLAIMABLE_BY_CUSTOMER[productType] === true;
}
__name(isProductClaimableByCustomer, "isProductClaimableByCustomer");
function isProductClaimableByPartner(productType) {
  return PRODUCT_CLAIMABLE_BY_PARTNER[productType] === true;
}
__name(isProductClaimableByPartner, "isProductClaimableByPartner");
function isProductOnlyClaimableByCustomer(productType) {
  return isProductClaimableByCustomer(productType) && isProductClaimableByPartner(productType) === false;
}
__name(isProductOnlyClaimableByCustomer, "isProductOnlyClaimableByCustomer");
function isProductOnlyClaimableByPartner(productType) {
  return isProductClaimableByPartner(productType) === true && isProductClaimableByCustomer(productType) === false;
}
__name(isProductOnlyClaimableByPartner, "isProductOnlyClaimableByPartner");
function doesFlexRequireCancellationProof(productType, requireCancellationProof) {
  return productType === ProductTypeEnum.WITHDRAWAL && requireCancellationProof;
}
__name(doesFlexRequireCancellationProof, "doesFlexRequireCancellationProof");
function requiresCancellationProof(productType, requireCancellationProof) {
  return productType === ProductTypeEnum.CANCELLATION_WITHOUT_PROOF || doesFlexRequireCancellationProof(productType, requireCancellationProof);
}
__name(requiresCancellationProof, "requiresCancellationProof");

// src/product/wakam-partnership-code-enum.ts
var WakamPartnershipCodeEnum = /* @__PURE__ */ function(WakamPartnershipCodeEnum2) {
  WakamPartnershipCodeEnum2["SK"] = "785092101";
  WakamPartnershipCodeEnum2["FR"] = "785091702";
  WakamPartnershipCodeEnum2["HU"] = "785092102";
  WakamPartnershipCodeEnum2["CZ"] = "785092103";
  return WakamPartnershipCodeEnum2;
}({});

// src/product-provider-enums.ts
var PRODUCT_PROVIDER_ENUM_TO_PRODUCT_PROVIDER_ID = {
  AVA: "287f41b9-e684-4ff6-8905-979532c570a3",
  WAKAM: "b3216341-bacc-41e1-8573-97b9f0e9f697",
  KOALA: "03850e8c-11b3-45a5-92f1-284b5b5e3329",
  AXERIA: "a17d857e-4f44-4006-b70e-f373f93125af",
  SEYNA: "c4695433-d085-4f87-8396-bf3a9b5c01da",
  MEETCH: "0cbb653e-c40d-4c0b-8e19-8778a07d27aa",
  EIR: "370a042c-0d9a-4d6e-9bdf-33212b24cdda",
  BATTLEFACE: "03044620-4cac-4e6f-bf74-7e1fd006a871"
};
var PRODUCT_PROVIDER_ENUM_TO_PRODUCT_PROVIDER_NAME = {
  AVA: "AVA insurance",
  WAKAM: "Wakam insurance",
  KOALA: "Koala service",
  AXERIA: "Axeria",
  SEYNA: "Seyna insurance",
  MEETCH: "Meetch",
  EIR: "Eir",
  BATTLEFACE: "Battleface"
};
var invertEnumMap = /* @__PURE__ */ __name((record) => Object.fromEntries(Object.entries(record).map(([key, value]) => [
  value,
  key
])), "invertEnumMap");
var PRODUCT_PROVIDER_ID_TO_PRODUCT_PROVIDER_ENUM = invertEnumMap(PRODUCT_PROVIDER_ENUM_TO_PRODUCT_PROVIDER_ID);
var PRODUCT_PROVIDER_NAME_TO_PRODUCT_PROVIDER_ENUM = invertEnumMap(PRODUCT_PROVIDER_ENUM_TO_PRODUCT_PROVIDER_NAME);

// src/product-provider.mapper.ts
(function(ProductProviderNameMapper2) {
  function fromProductProviderId(productProviderId) {
    if (productProviderId in PRODUCT_PROVIDER_ID_TO_PRODUCT_PROVIDER_ENUM === false) {
      throw new Error(`Cannot map product provider ID "${productProviderId}" to ProductProviderEnum member: unknown product provider ID.`);
    }
    return PRODUCT_PROVIDER_ID_TO_PRODUCT_PROVIDER_ENUM[productProviderId];
  }
  __name(fromProductProviderId, "fromProductProviderId");
  ProductProviderNameMapper2.fromProductProviderId = fromProductProviderId;
  function fromProductProviderName(productProviderName) {
    if (productProviderName in PRODUCT_PROVIDER_NAME_TO_PRODUCT_PROVIDER_ENUM === false) {
      throw new Error(`Cannot map product provider name "${productProviderName}" to ProductProviderEnum member: unknown product provider name.`);
    }
    return PRODUCT_PROVIDER_NAME_TO_PRODUCT_PROVIDER_ENUM[productProviderName];
  }
  __name(fromProductProviderName, "fromProductProviderName");
  ProductProviderNameMapper2.fromProductProviderName = fromProductProviderName;
})(ProductProviderNameMapper || (ProductProviderNameMapper = {}));
var ProductProviderNameMapper;

// src/product-provider-id.mapper.ts
(function(ProductProviderIdMapper2) {
  function fromProductProviderEnum(productProvider) {
    return PRODUCT_PROVIDER_ENUM_TO_PRODUCT_PROVIDER_ID[productProvider];
  }
  __name(fromProductProviderEnum, "fromProductProviderEnum");
  ProductProviderIdMapper2.fromProductProviderEnum = fromProductProviderEnum;
})(ProductProviderIdMapper || (ProductProviderIdMapper = {}));
var ProductProviderIdMapper;

// src/publication-status.ts
var PublicationStatusEnum = /* @__PURE__ */ function(PublicationStatusEnum2) {
  PublicationStatusEnum2["NOT_PUBLISHED"] = "NOT_PUBLISHED";
  PublicationStatusEnum2["PUBLISHED"] = "PUBLISHED";
  PublicationStatusEnum2["PUBLISHED_WITH_DIFFERENCES"] = "PUBLISHED_WITH_DIFFERENCES";
  return PublicationStatusEnum2;
}({});

// src/risk-management/contract-risk-attribution.ts
var ContractRiskAttributionStatusEnum = {
  ATTRIBUTION_REQUESTED: "ATTRIBUTION_REQUESTED",
  ATTRIBUTION_FAILED: "ATTRIBUTION_FAILED",
  ATTRIBUTION_CONFIRMED: "ATTRIBUTION_CONFIRMED",
  ATTRIBUTION_RELEASE_REQUESTED: "ATTRIBUTION_RELEASE_REQUESTED",
  ATTRIBUTION_RELEASE_FAILED: "ATTRIBUTION_RELEASE_FAILED",
  ATTRIBUTION_RELEASE_CONFIRMED: "ATTRIBUTION_RELEASE_CONFIRMED",
  TRIGGERED: "TRIGGERED",
  TRIGGER_HANDLED: "TRIGGER_HANDLED",
  TRIGGER_UNHANDLED: "TRIGGER_UNHANDLED"
};

// src/risk-management/financial-backer.ts
import { DateTime, Duration } from "luxon";
var ensuro = {
  id: "81786148-0bda-4423-b498-c8145604c399",
  name: "Ensuro",
  exposure: {
    currency: "USD"
  },
  premiumCoefficient: {}
};
var ENSURO_CURRENCY = "USD";
var ENSURO_MAX_EXPOSURE_IN_USD = 5e6;
var ENSURO_POLICY_MAX_DURATION = Duration.fromObject({
  days: 364
});
var ENSURO_MAXIMUM_COMPENSATION_ALLOWED = 19190;
var NAYMS_PARTNERSHIP_START_DATE = DateTime.fromISO("2025-05-17");
var NAYMS_PARTNERSHIP_END_DATE = DateTime.fromISO("2025-09-30");
var NAYMS_MAX_EXPOSURE_IN_USD = 12e5;
var NAYMS_CURRENCY = "USD";
var NAYMS_MAXIMUM_COMPENSATION_ALLOWED = 5e3;
var nayms = {
  id: "6398caf7-fc9d-4ea2-9872-c741812554a4",
  name: "Nayms",
  exposure: {
    currency: NAYMS_CURRENCY
  },
  premiumCoefficient: {}
};
var KOALA_CURRENCY = "EUR";
var koala = {
  id: "48f5d73e-6c91-4009-9dfb-8e618b09efe3",
  name: "Koala",
  exposure: {
    currency: KOALA_CURRENCY
  },
  premiumCoefficient: {}
};
var FINANCIAL_BACKERS_EXPOSURE_THRESHOLD = [
  {
    name: koala.name,
    threshold: 16e5
  }
];
var EIR_CURRENCY = "EUR";
var EIR_MAXIMUM_COMPENSATION_ALLOWED = 5e3;
var eir = {
  id: "370a042c-0d9a-4d6e-9bdf-33212b24cdda",
  name: "Eir",
  exposure: {
    currency: EIR_CURRENCY
  },
  premiumCoefficient: {}
};
var SEYNA_CURRENCY = "EUR";
var SEYNA_MAXIMUM_COMPENSATION_ALLOWED = 7e3;
var seyna = {
  id: "48ccaa7a-542e-49cb-97ec-f5a23da7f44a",
  name: "Seyna",
  exposure: {
    currency: SEYNA_CURRENCY
  },
  premiumCoefficient: {}
};
var FINANCIAL_BACKERS = [
  ensuro,
  nayms,
  koala,
  eir,
  seyna
];
var ACTIVE_FINANCIAL_BACKERS = [
  koala,
  eir,
  seyna
];
var FINANCIAL_BACKERS_SUPPORTING_CLAIM_DELETION = [
  nayms,
  koala,
  eir,
  seyna
];

// src/risk-management/risk-attribution-error-types.ts
var RiskAttributionErrorTypesEnum = {
  UNKNOWN: "UNKNOWN",
  CONTRACT_DURATION_LIMIT_EXCEEDED: "CONTRACT_DURATION_LIMIT_EXCEEDED",
  CONTRACT_END_DATE_AFTER_FINANCIAL_BACKER_END_DATE: "CONTRACT_END_DATE_AFTER_FINANCIAL_BACKER_END_DATE",
  CONTRACT_HAS_EXPIRED: "CONTRACT_HAS_EXPIRED"
};

// src/risk-management/risk-attribution-release-error-types.ts
var RiskAttributionReleaseErrorTypesEnum = {
  UNKNOWN: "UNKNOWN"
};

// src/risk-management/risk-event.ts
var RiskEventTypesEnum = {
  RISK_ATTRIBUTION_REQUESTED: "RISK_ATTRIBUTION_REQUESTED",
  RISK_ATTRIBUTION_FAILED: "RISK_ATTRIBUTION_FAILED",
  RISK_ATTRIBUTION_CONFIRMED: "RISK_ATTRIBUTION_CONFIRMED",
  RISK_ATTRIBUTION_RELEASE_REQUESTED: "RISK_ATTRIBUTION_RELEASE_REQUESTED",
  RISK_ATTRIBUTION_RELEASE_FAILED: "RISK_ATTRIBUTION_RELEASE_FAILED",
  RISK_ATTRIBUTION_RELEASE_CONFIRMED: "RISK_ATTRIBUTION_RELEASE_CONFIRMED",
  RISK_TRIGGERED: "RISK_TRIGGERED",
  RISK_TRIGGER_HANDLED: "RISK_TRIGGER_HANDLED",
  RISK_TRIGGER_UNHANDLED: "RISK_TRIGGER_UNHANDLED"
};

// src/risk-management/risk-trigger-handling-error-types.ts
var RiskTriggerHandlingErrorTypesEnum = {
  UNKNOWN: "UNKNOWN"
};

// src/risk-management/seyna-binder.ts
var SeynaBinders = {
  CAR_RENTAL: "SEYNA_CAR_RENTAL",
  CHANGE_FOR_ANY_REASON: "SEYNA_CHANGE_FOR_ANY_REASON",
  FLEX_80: "SEYNA_FLEX_80",
  FLEX_90: "SEYNA_FLEX_90",
  HIGH_VALUE_BOOKING: "SEYNA_HIGH_VALUE_BOOKING",
  OMIO_SEMI_REFUNDABLE: "SEYNA_OMIO_SEMI_REFUNDABLE",
  OTHERS: "OTHERS"
};

// src/route.ts
var RouteModeEnum = /* @__PURE__ */ function(RouteModeEnum2) {
  RouteModeEnum2["BUS"] = "BUS";
  RouteModeEnum2["TRAIN"] = "TRAIN";
  RouteModeEnum2["FERRY"] = "FERRY";
  RouteModeEnum2["FLIGHT"] = "FLIGHT";
  return RouteModeEnum2;
}({});
var GENERIC_ROUTE_MODE_VALUES = Object.values(RouteModeEnum).filter((mode) => mode !== "FLIGHT");

// src/scheduled-email-reminder.ts
var ScheduledEmailReminderTypes = {
  SUBSCRIPTION_PAYMENT_FIRST_REMINDER: "SUBSCRIPTION_PAYMENT_FIRST_REMINDER",
  SUBSCRIPTION_PAYMENT_LAST_REMINDER: "SUBSCRIPTION_PAYMENT_LAST_REMINDER"
};

// src/segment-stop-status.ts
var StopStatusProviderEnum = /* @__PURE__ */ function(StopStatusProviderEnum2) {
  StopStatusProviderEnum2["KOALA"] = "KOALA";
  StopStatusProviderEnum2["PARTNER"] = "PARTNER";
  return StopStatusProviderEnum2;
}({});
var StopStatusEnum = /* @__PURE__ */ function(StopStatusEnum2) {
  StopStatusEnum2["ACTIVE"] = "ACTIVE";
  StopStatusEnum2["ARRIVED"] = "ARRIVED";
  StopStatusEnum2["CANCELED"] = "CANCELED";
  StopStatusEnum2["DIVERTED"] = "DIVERTED";
  StopStatusEnum2["SCHEDULED"] = "SCHEDULED";
  StopStatusEnum2["UNKNOWN"] = "UNKNOWN";
  return StopStatusEnum2;
}({});

// src/subscription-payment.ts
var SubscriptionPaymentTypes = {
  APEXX: "APEXX",
  STRIPE: "STRIPE",
  MANUAL: "MANUAL",
  COMMERCIAL_GESTURE: "COMMERCIAL_GESTURE"
};
var SubscriptionPaymentStatuses = {
  COMPLETED: "COMPLETED",
  DECLINED: "DECLINED",
  EXPIRED: "EXPIRED",
  FAILED: "FAILED",
  INCOMPLETE: "INCOMPLETE"
};
var ApexxPaymentStatuses = {
  AUTHENTICATED: "AUTHENTICATED",
  TOKENISED: "TOKENISED",
  AUTHORISED: "AUTHORISED",
  CAPTURED: "CAPTURED",
  SETTLED: "SETTLED",
  REFUNDED: "REFUNDED",
  CANCELLED: "CANCELLED",
  DECLINED: "DECLINED",
  FAILED: "FAILED",
  PENDING: "PENDING",
  INVALID_REQUEST: "INVALID_REQUEST",
  UNKNOWN: "UNKNOWN"
};
var StripePaymentIntentStatuses = {
  REQUIRES_PAYMENT_METHOD: "requires_payment_method",
  REQUIRES_CONFIRMATION: "requires_confirmation",
  REQUIRES_ACTION: "requires_action",
  PROCESSING: "processing",
  REQUIRES_CAPTURE: "requires_capture",
  CANCELED: "canceled",
  SUCCEEDED: "succeeded"
};
var ManualPaymentMethods = {
  BANK_TRANSFER: "BANK_TRANSFER",
  CHECKOUT_PAYMENT_LINK: "CHECKOUT_PAYMENT_LINK",
  OTHER: "OTHER"
};

// src/taxes.ts
import { DateTime as DateTime2 } from "luxon";
var FRENCH_IPT_RATE = 0.09;
var LEGACY_PRICER_MIGRATION_DATE = DateTime2.fromISO("2025-10-25");
var PRODUCTS_PRICED_BY_LEGACY_PRICERS = [
  "3e50fee6-a119-4b66-8db9-efab9c79baf6",
  "f42db1b1-182d-5a12-aff9-a23097c91d34",
  "0f6c5b3e-7617-4dd3-bc47-33d07220b637",
  "81950581-99bc-445c-a37b-ea5f88c423c0",
  "590d0e25-534d-4081-8ad7-82f49b5d1349",
  "3a1eb53d-f5f9-44f5-8026-2309b36a23ea",
  "831cfb15-c7fc-4825-a63d-c94f63fcd8cc",
  "e52e07c1-5115-59ce-83db-2197ea1cd727",
  "baecfc9a-1852-4a6d-ba35-dc0ac3b5b465",
  "c6ecf0d6-f697-4aa7-954e-d4d721059b7b",
  "f6240200-f056-5ff2-abb4-12730774433f",
  "bb8479e2-096e-5974-929b-a803ca765960",
  "44b8019c-8e06-4c5b-ae88-7938e134c083",
  "8e83b9bc-884e-4e62-aef3-a63c8ee20581",
  "b4884bd9-fd51-4eeb-bc7b-0dd5d4432bde",
  "8c5e521c-1035-473e-a2bb-6358c22e0377",
  "c963375a-61cc-57e2-9090-430590c901d5",
  "49dbdd66-2e9b-564b-a7a1-801e4acc68ad",
  "d246fc79-1055-520b-b661-8937e0bdf0a9",
  "54204f71-3ff8-5e2b-8e83-5a90f6ccc11f",
  "f90b0b44-c194-4bd4-b5ca-0e38ad79760d",
  "9993bac2-2b5d-4d72-ba7a-9760f8887674",
  "3b8f7c84-457e-4166-9844-ecafd9a5a22e",
  "71a08569-654f-4ca0-986e-61a22a76339f",
  "0fed55f8-c253-43f6-90f0-2666bf193005",
  "0def7c6d-3c9c-42ef-be14-f8ee13e77466",
  "964f271a-10b6-5479-8ef5-3ef9396f59fd",
  "95252384-68e6-459e-88bf-a13f208e0151",
  "4da5a8bd-9ef0-46d2-843a-48d1dd68cede",
  "23e700a6-b350-470e-adab-7219b57c6f96",
  "2440da4b-7161-4a69-8adb-56e006a10226",
  "88f43c62-57b8-400c-b559-136227ca93c9",
  "8e21fa3a-f1b8-5e58-8404-93b5204eae22",
  "3294a37e-d3d1-4435-bfbe-a0fc6dd32198",
  "d427b1a4-c3c7-448c-a8d7-4c88223d1bfb",
  "5029b915-32ca-407a-9afb-3463c915d2f5",
  "46ff3a31-8f71-482b-8d03-bf0b2df2dbef",
  "f495cc21-526e-4523-98ab-d79141e3e8f2",
  "c96c0cf3-80fb-43d1-9899-30503270c89c",
  "2c30fdec-c41b-46b1-84be-031bada4a8ab",
  "52d9bc5a-709a-400b-a9d5-223b886f3d64",
  "81df46ae-311d-4a3b-be71-dfa1cc85f6af",
  "97385b5c-3fa6-42a1-9691-58fcb2f6e6e2",
  "b942099a-b55a-4a5c-a792-7fea3dc8820c",
  "50b31362-56e2-479f-8338-86af15e6c93a",
  "47ee9ec3-57f9-4f82-b87f-7951ceb64ef4",
  "3660a1fa-40e9-4b02-b0af-97b73b0a52f0",
  "2900bc2d-2f1e-5021-bd2f-7553df41ca12",
  "56ae692b-9d22-4356-a1c0-9908244cc5bb",
  "3bfcbdfd-5aed-52e8-98f1-182d26d42bf1",
  "ff5a17cb-918d-4453-9573-75a643cc4f0b",
  "f51aeae7-0d01-4311-aeb1-73aaafc7d665",
  "0ffb7bcd-24d5-4d30-a57e-b7b5e41a7b1c",
  "2d57341d-8716-4db5-8fb5-1129394246c9",
  "0722338c-af9c-4134-a997-0574bbc10685",
  "c01b74a2-d414-5b3d-b394-5d64a62223c7",
  "b90cb1b0-e21e-4957-9051-4e866aaf9b30",
  "0983bef8-e95f-4664-980c-8319424959b2",
  "581ec568-277c-43ba-8bdf-519638caba3a",
  "c6f76d90-f981-46af-935c-9bf8f37988b6",
  "a886c9e9-d252-4ecc-8f68-3bb716abfced",
  "64f205bd-3d23-518f-a1ae-0403ab9021ff",
  "422336a9-7b46-430b-bfb8-5e55503ebfda",
  "4efc390c-cf6e-4164-8f3a-9ed4f976bcf1",
  "c6815fdb-dd4c-43c8-9566-91557ef61893",
  "96b854e5-38e2-4de8-b0a1-1f2e49140686",
  "406d9473-43c0-4b58-a24b-1ae2648ff4d3",
  "c0205e37-2bdb-44e1-b3e4-d51ad6b0ea2d",
  "3a9fb62b-1abb-49a6-8250-50de47885286",
  "9dc8e046-d531-4147-b5d4-8ad7d0d67be6",
  "78cbf3bf-ff73-4f96-8aaf-c316662b18aa",
  "cdc88409-7f9d-414a-9bed-7726c9205649",
  "e0fdeea8-e588-4cb8-8823-2fcef17090ca",
  "831c7bc4-c05a-413f-9673-dba64b2a7ff8",
  "8010bb68-2fcb-4cbc-9dcc-926db2739073",
  "08d67543-b150-4a0b-9e62-82222525315e",
  "da2cde60-bc77-45da-8364-a52fac2a06e9",
  "186e7b26-28d9-436a-ac20-b4dac342ee84",
  "1828d087-5327-4a55-92aa-387974490db4",
  "2476de57-7b28-4e1a-bf06-abb5573eb495",
  "98cef824-60eb-44fe-a2bd-585c808f1bdc",
  "6a10898c-73d7-4f0d-9f0b-51844d750724",
  "d4820c2e-9afb-4814-91bf-8fae973cc45a",
  "8ebc7f3f-5126-4bf6-872f-6df589cc64e5",
  "deb193b5-cc6f-4693-b01d-9fb4e78e5ba3",
  "c0e70ebf-3c53-4f37-bf3c-acb497b6666e",
  "03cef90a-3ef1-4e09-9020-6bbc10dbfd03",
  "c7fa9550-e89a-4b14-8d8c-ac730c8ea89a",
  "ea678658-9237-4309-92dc-778379008f96",
  "65af4f21-5f12-438e-ba35-c9d526908020",
  "4bfaefc8-3234-4924-9099-6ca3f678c080",
  "cc5b78ad-3fc5-471f-b88f-9679aaded3a9",
  "2d1e1240-ed96-42c4-8abc-7bcac4171a39",
  "f5396b02-1be2-4a43-b792-01d839c53f9d",
  "fed10dd7-28c0-435b-a5f6-a8cdca374a7d",
  "1aaf115f-26f5-4148-a31c-23533ea26811",
  "8109f17e-6e0b-4cf7-95b3-fba775b9f50f",
  "cbc67924-7d5d-43a0-9711-ed13f7922368",
  "8e2360ba-a998-4e89-9202-80f16650a191",
  "164cf20b-87da-4660-ad3f-e27b71bc8c7a",
  "8937348d-6f39-4d37-8afb-1e7c9ba74cd7",
  "afc55f64-0974-4e37-8866-ff9593edbc82",
  "0427e139-1915-4de1-a033-c300553b30f5",
  "9bcffdee-db38-4c82-8aa3-74a38dffc75b",
  "ac4fdead-4733-48e7-a64d-03c8e3a9c525",
  "35cd49a9-81e8-45db-a843-f0c82de938ab",
  "d24a2aef-44d2-4322-b17f-781d371a8d77",
  "759fa9d6-d0f9-48bf-ac13-ead8246d7fd5",
  "a7d77d75-d144-41ff-8745-ace1056c73b9",
  "03c3f640-8df9-4137-9bd8-4a1a33e36f16",
  "6b0a4fad-85e0-407e-9ad1-42b7456e2113",
  "6e95edb6-382c-45b4-9c16-1fb5b4164964",
  "29ac5096-12d6-4bd3-8527-7314a84460db",
  "9cc7065c-46b0-4bd4-8104-73e2d638426c",
  "beeb38df-1206-4f33-9f60-925c25fff15f",
  "5679a8c9-471e-46c1-b054-217458c741f6",
  "68c87369-a90f-4e3c-b488-4d3568703b42",
  "1e088bb5-565e-4964-b225-184ed7125764",
  "715c66f1-f1d2-475e-9ded-ffb40eaac720",
  "defc2bb3-9a97-4490-b1fd-aaddbf1c14b3",
  "66839940-64fb-49c2-87be-eb8903823a59",
  "73d4c704-63ae-4c4c-875b-54402a16f74a",
  "030145cc-ab5f-4c29-a36f-62b093d684b8",
  "54e3ded5-c4ba-4b05-8edf-9cda13c82e46",
  "93b48fcc-dc66-497e-9b40-55fce4e94df0",
  "157de296-b23e-524b-a464-28b276e211b8",
  "165ecf28-33b8-40fc-a41a-df3b270843e7",
  "1d58623b-6461-44ec-95ac-888a07d5700f",
  "0a74ab95-8eac-4339-90aa-9e05cfca365d",
  "b5db6266-0ac7-497d-ae13-01cbc6ebd856",
  "c76cebad-756f-45c9-a308-28b9151ec467",
  "47a4407c-86df-429f-a941-19a5715517fe",
  "70da58e7-131d-45ae-b61b-3ab468421992",
  "ce709211-439c-42b5-95e2-d47e1dff4dea",
  "9b68e585-0d42-4738-a741-9e7bc2eeb511",
  "6f29fd54-29cb-4a17-8977-4581b8770170",
  "36763687-5273-4ff5-bcf2-477a673a5ac7",
  "07fa8a2a-6d0f-41e5-ae12-d06031cef350",
  "2284249b-5260-4a8f-a716-61642467b2e6",
  "1b7b102e-1c44-42c4-9110-b5e2db335deb",
  "b69e083a-0296-4340-964b-ade64f69e98d",
  "ab4be4e3-fc4c-4ee8-8521-59a50cefa350",
  "a3b9db8b-c035-48ea-b819-4313a982a246",
  "2abf5303-4bfd-4230-b834-eecd56214305",
  "5b0c4186-2d54-4e21-bd1e-b82f50850748",
  "705d0e30-8bdb-41e8-a5f9-6124bf42e67c",
  "8c5bf767-4080-411a-bb1a-572d1dca6f9e",
  "d704f29c-201b-4708-bdac-e3ffd92e7ed5",
  "fe17bd67-0b71-45e1-8248-6d413e512c16",
  "b77187ab-dcc0-498a-833b-dcc38576e42e",
  "db86d03e-ea90-49db-a768-547271eb1514",
  "e18d316f-792d-44a8-a309-56852124ec37",
  "969c8373-5add-4730-ba46-43987dedb5ce",
  "0698a4d9-7baa-4153-866d-ef8d3c14af2e",
  "f3114a61-c4a6-4328-bfbc-658043835a50",
  "78f76fae-d10c-45ab-8681-bf698daf12de",
  "28276124-3324-4bc2-9e22-e1c405605f18",
  "4d358010-4aec-4eaa-8ed0-3219dbbf0ca5",
  "0525213e-2e71-48fa-bd6c-338376ffa520",
  "8c94d2ea-2a05-4f43-ab14-ed91a870d344",
  "7cc11e18-26de-4497-af7e-aa538adb6c41",
  "a152e46c-5813-4cf4-86c8-633e27b1002e",
  "d06d98e2-7e8d-4425-b21f-df8f7c17e965",
  "fa4e56b3-e50b-440c-926d-90fec0452e5f",
  "0a78df9e-e46c-4b1f-9ddc-aa5ae3eef457",
  "5811560f-70b0-4642-8a03-cc2a6689c49c",
  "bb8ee75b-b45d-4b02-9972-55340cf3d411",
  "db9f122b-6cf2-4001-a4ae-196f3f1b4a23",
  "12c408e8-222e-4a9e-8d67-9c810da5f2aa",
  "f1742904-88f2-4b4f-9602-9a3421221469",
  "915b6211-4ebc-4059-83f1-4720d1095eca",
  "69468e55-fcf0-4322-b8e4-86f3991c24ba",
  "bf1bed71-957b-4868-909b-1c2722184972",
  "48158bbe-6f6b-4a0d-b29f-4c9ebd24960d",
  "b73ad3f5-95df-42aa-9d7b-97203d92ba80",
  "97a84bfc-bf15-4d57-8f29-e50eda8fa31a",
  "e7020608-3cf5-42a6-abad-33129e68c757",
  "4473f7da-44a7-45d6-bc7e-110331c4e55b",
  "d7973c12-9de6-45da-adb5-6ce6b1187355",
  "80d2fac4-a1eb-4287-b68d-be33216736b6",
  "b47ef096-cd9b-4bb6-8548-0c529feba55c",
  "cc70cb96-c4cc-49b0-a93d-138096cc57ef",
  "088cbab7-fba4-4358-88a1-8104910f8d10",
  "2418f974-d57b-4803-a434-86dd8c2d3f01",
  "cde7f2d2-1b12-4f56-8ab2-8fad30ca2f2c",
  "bf0b9106-e6e8-4432-ab8d-b0cfb3cf54e7",
  "e8e2a659-7b3f-49e9-a57f-5186f3e07105",
  "b0943f05-dc62-4599-a1eb-7a4a5b9edc99",
  "cb7e7ece-4d51-428f-bac6-db0fe2bdd2b2",
  "033abffd-41d5-4f87-b3ae-51d922f0cead",
  "2400caca-e32e-4f8e-bf13-de22e21a9d27",
  "bba810b4-0348-4f0f-aa6a-b80ee1f67440",
  "5fcdb7b5-7ee4-43c4-9111-e36ff9d0929d",
  "1553ab1a-db4b-41af-975f-d05be98508a2",
  "63142334-60ba-4a2f-803b-9785d4846e7f",
  "b03f0136-91c2-4d66-9064-28799f289dda",
  "fb14e08a-a358-4157-b798-3bc031f7ab95",
  "188cc1b8-cdaa-4553-b0d7-0d8edd78ca14",
  "9178b994-5dc5-4974-a1ec-70e758ca062f",
  "12beea2d-4901-47f8-996a-d38d0829c6a2",
  "7ff7ba72-38f8-442f-b5e9-7e086cea06fe",
  "4937738b-b1fc-4840-97f3-79bb22212c6a",
  "eb8855f4-b0d9-4624-8630-4c0350007cce",
  "5161f94a-ce85-4a01-8d41-09e05a5d7b09",
  "9f4dce36-eba8-443f-aef3-af85a05980b9",
  "54f68a66-cb0b-4dd2-b006-3c07d7d72786",
  "0b387a26-9e01-4346-be90-765a2c84fe89",
  "fa38841c-ec15-40eb-9910-3a4bafe3797a",
  "f3433383-2518-4b96-a84d-401b834889fa",
  "5c09dd60-4da6-4133-9edb-dd04c013868f",
  "98b5674b-669c-4874-8f61-5f3c19309a03",
  "9009cd6b-7809-4bcd-a44c-a197927d5024",
  "98d6319e-e73b-416d-b1ed-c3bb2369fc97",
  "c945a71b-2aac-4275-80a0-d1b2bfb7bf42",
  "b0b03379-8fb0-420f-a9b3-e6504dbcd291",
  "aafae4d4-febc-48a5-8544-eacd3ea6e101",
  "688f8ff9-89b6-4ee9-8068-11bcff2c7d5a",
  "b635e7e1-47c9-4779-99b4-ac8b45241a7b",
  "d5165027-786f-46db-81cd-21ca96dc949a",
  "159678b5-6faa-4774-a87a-335dfb83e1bd",
  "63c4fd81-2fff-41da-8dcf-bfa252284b3a",
  "dbc12f1a-d85a-44c4-b468-4b85f09a525d",
  "56164525-ad77-4b2f-a05d-01b25d1b34a1",
  "9ca7f185-de9a-4f29-a389-423636426d4d",
  "d2154d72-f3d6-4504-bdc3-e1f8d801d4d9",
  "6a8c8281-6e5f-4067-bc7a-ca99eb886601",
  "296f4be0-5d4a-4dbf-acec-ccfcd9693477",
  "e7ecd3a0-4274-45f5-ae89-a620f9cdcc8e",
  "49993e54-8601-437d-81ee-93814a80e3fa",
  "b233e790-a13b-4546-9a2d-bbd0dbdce848",
  "a389171b-f237-4782-afa3-b77a90074825",
  "df1a5f5b-d169-4771-9e3f-c56a4a6a2300",
  "6610df44-cc79-4974-a2ac-9debc1fcd51b",
  "3c167d89-987e-42af-a9c7-115fac7f88c9",
  "b52accf9-3736-480f-b8a5-7b9087066d8e",
  "3619b277-6648-41c7-953f-742fa4857e5e",
  "ff2fcf0a-8722-403a-89f3-f751ddae07fd",
  "5fdeb5b7-467b-4700-a0d8-6f93f47d1582",
  "c1454382-f1d3-4b32-9a86-c13ca18f9899",
  "222c1940-3a54-4c79-91f7-a5c19aac8522",
  "6eff380e-f959-4a03-8db8-477886223588",
  "973f54e2-51dc-42f3-953d-972577b9107c",
  "ba3c0eed-a8ee-4f98-b27d-32e980351df3",
  "87f213bb-6502-4c78-992f-d688e6b3b637",
  "5b697a3d-2120-4411-872b-eb5ea6165730",
  "83a5efea-3745-45a1-a7c7-8da6509ad6d8",
  "d9fa5f27-5e05-4209-ad71-c387a790ed85",
  "055d4ba4-e292-4f13-8c53-e3c4b7e120d6",
  "e9afac09-de72-490e-ac43-b8bb2dee7e97",
  "6869fa1d-39f2-4d5f-b424-68ca07b4f409",
  "1b7d8652-6895-4d7d-ab08-8c0f5ccedc2b",
  "9662d9a5-8bf3-4d87-83d6-aea5296a011f",
  "426c4805-d2d2-4c64-a66e-1f472fd04854",
  "d736ecca-8e2a-49db-9623-b4f35d3235c1",
  "3a981331-7f93-4c21-99d5-038106229e3a",
  "c08ec44c-4e8e-4c63-b325-3d8bf07faff0",
  "a5d6d5cc-8004-46e5-9f6a-ca0594a3503d",
  "383e8dbe-6536-4697-9bb2-23672ebccc1b",
  "57348f4f-b25f-481f-bf38-d6173adbe159",
  "e894e967-a87f-47fe-85c6-7258f234ae61",
  "d1526907-bbd6-410d-94f9-0120f38f2095",
  "e22f20ea-11b3-4e5a-ad8f-c6f7344180bd",
  "6dae3e3e-b543-4108-bd0f-9b8460c2a34c",
  "6905c55e-c408-42c6-9e2d-c81dd202f754",
  "a4e96b8f-89bc-4125-afe2-1e46f19dfc64",
  "047b84c7-8aee-404c-82f0-d2c05c2bd3db",
  "a4c333f9-7735-4b9d-9563-adf76c6f2a65",
  "cdd31bc2-31e1-46fa-b473-7095f6914052",
  "0c30abf6-943d-48c4-9388-57630831bbb7",
  "5dacfa9b-4caf-4124-81a4-cf26a9bfe4dc",
  "ac982149-562b-4ba2-8b06-27924fe7015e",
  "ddcd47e1-f502-4f04-aef9-2b07a6e3262a",
  "cb47c94b-2044-480e-9a9c-d0ca99c27477",
  "b4a30bb4-f87b-49f8-ab06-87a02b4834e5",
  "af569d5b-0fdb-4b32-8e0a-e6a5202d8b94",
  "fcd55909-5615-46cf-b913-6f43006bedf0",
  "43709836-939c-4c4a-82e6-617d40049c8d",
  "ffa76ac3-35d3-4fe7-b4ad-42bd14719e90",
  "8d66cce1-331d-4ef3-bb49-3e524b1cda61",
  "ede271e2-91ed-45da-953b-0f6d94c44f6d",
  "f95c4216-7b75-43eb-9b31-6d5b44a69e8c",
  "f3308006-cd3c-4809-adb5-38d67369704a",
  "dcd9ef50-130e-4397-9d3a-d6b3566bf56b",
  "8d7521c3-ea27-42f1-98d3-5fa07aac3027",
  "4c1d83ab-2801-488b-b5bc-4bcdfbd43485",
  "55c3acce-da4b-44d2-b76d-4f6cfe2c10f6",
  "9f42b5ee-991f-4fac-8130-b107b1ad405f",
  "98641b70-2f3a-4112-b140-e8e0375ca019",
  "26d1990c-a319-41dd-adff-4ec7fa528b1d",
  "54a53e6f-88a8-4ea0-ad8d-1027244d2a95",
  "19326157-fd30-4b3a-9c2c-0942597c9d1e",
  "9773d7cc-6ecc-4579-b802-79a55e8fd7b0",
  "6732207e-f91e-4598-bd87-78161dd51c2d",
  "28aba680-79d1-449b-bc51-50f0ef722819",
  "1e5cf3e2-2601-4eb3-8c94-ccab67d9b36f",
  "bac1ec78-5913-4056-a57f-3134bdf18205",
  "72171993-c991-4691-bb88-497080fd3208",
  "c77bf652-bdd5-49e7-a912-09884b274670",
  "176e4378-ab4e-44c5-82af-2561bb3fef01",
  "7f3a348c-8dd0-42a0-82f6-7d4dd11fa517",
  "ddd29a26-666d-4fde-9788-888c57c91a5a",
  "380b131a-1f99-4960-adf5-bde322aaba1c",
  "2ed57111-c5c5-45bc-8b7b-05c36f287be1",
  "0f523267-d4d4-4daa-90f9-10f83ecc4476",
  "285bca0f-62ca-4baa-bbb4-81a25d5afb26",
  "15625d4f-99fa-4a16-b6e4-b0ee5ccebf57",
  "ced8f17a-3ebc-4fc0-9611-71d541014f18",
  "5ad7a3f5-c864-48d3-8ddf-efddea65e4a0",
  "54ccb7f2-761c-42ca-809d-4fdb73dd3474",
  "b140db41-2880-4450-ad47-464a0a06ceba"
];

// src/traveler.ts
var AgeRangeEnum = /* @__PURE__ */ function(AgeRangeEnum2) {
  AgeRangeEnum2["INFANT"] = "INFANT";
  AgeRangeEnum2["CHILD"] = "CHILD";
  AgeRangeEnum2["ADULT"] = "ADULT";
  AgeRangeEnum2["SENIOR"] = "SENIOR";
  return AgeRangeEnum2;
}({});
export {
  ACTIVE_FINANCIAL_BACKERS,
  ALLOWED_COMMISSION_COEFFICIENT_PROPERTIES_PER_COVERED_EVENT,
  ALLOWED_COMPENSATION_PROPERTIES,
  ALLOWED_PRICING_COEFFICIENT_PROPERTIES,
  ALLOWED_PRICING_COEFFICIENT_PROPERTIES_PER_COVERED_EVENT,
  AffinityCriterionEnum,
  AffinityEnum,
  AgeRangeEnum,
  ApexxPaymentStatuses,
  AuthAttemptApplications,
  BaggageDisruptionTypes,
  BankDetailsTypeEnum,
  BattlefaceBundleEnum,
  BattlefacePolicyFileTypeEnum,
  BusinessContributorEnum,
  CURRENCIES,
  ChallengeTypes,
  ClaimAcceptedReasonEnum,
  ClaimEligibilityConditionNames,
  ClaimPaymentFlowEnum,
  ClaimPaymentStatusEnum,
  ClaimRejectedReasonEnum,
  ClaimStatusEnum,
  ClaimTriggers,
  ContractDocumentStatuses,
  ContractDocumentTypes,
  ContractDocumentUploadStatuses,
  ContractDocumentUploaders,
  ContractRiskAttributionStatusEnum,
  CountryCodes,
  CoveredEventTypeEnum,
  CwpCancellationReasons,
  DeletionReasonEnum,
  EIR_CURRENCY,
  EIR_MAXIMUM_COMPENSATION_ALLOWED,
  ENSURO_CURRENCY,
  ENSURO_MAXIMUM_COMPENSATION_ALLOWED,
  ENSURO_MAX_EXPOSURE_IN_USD,
  ENSURO_POLICY_MAX_DURATION,
  ExtendedPriceSettingTypeEnum,
  ExternalClaimProviderEnum,
  FINANCIAL_BACKERS,
  FINANCIAL_BACKERS_EXPOSURE_THRESHOLD,
  FINANCIAL_BACKERS_SUPPORTING_CLAIM_DELETION,
  FLIGHT_PRICING_FACTORS,
  FRENCH_IPT_RATE,
  FlightStatusEnum,
  FlightStatusProviderEnum,
  FraudProductConditionNameEnum,
  GENERIC_ROUTE_MODE_VALUES,
  GeographicalAreaEnum,
  JSON_LOGIC_ALWAYS_TRUE_CONDITION,
  JSON_LOGIC_COMPARATORS,
  JSON_LOGIC_LOGICAL_OPERATORS,
  KOALA_CURRENCY,
  LANGUAGES,
  LEGACY_PRICER_MIGRATION_DATE,
  ManualPaymentMethods,
  MeetchProductType,
  NAYMS_CURRENCY,
  NAYMS_MAXIMUM_COMPENSATION_ALLOWED,
  NAYMS_MAX_EXPOSURE_IN_USD,
  NAYMS_PARTNERSHIP_END_DATE,
  NAYMS_PARTNERSHIP_START_DATE,
  NON_STANDARD_LANGUAGES,
  OtherProductConditionNameEnum,
  PRODUCTS_PRICED_BY_LEGACY_PRICERS,
  PRODUCT_CLAIMABLE_BY_CUSTOMER,
  PRODUCT_CLAIMABLE_BY_PARTNER,
  PRODUCT_PROVIDER_ENUM_TO_PRODUCT_PROVIDER_ID,
  PRODUCT_PROVIDER_ENUM_TO_PRODUCT_PROVIDER_NAME,
  PRODUCT_PROVIDER_ID_TO_PRODUCT_PROVIDER_ENUM,
  PRODUCT_PROVIDER_NAME_TO_PRODUCT_PROVIDER_ENUM,
  PartnerAccountGroupEnum,
  PartnerBrandingModeEnum,
  PartnerBusinessCategoryEnum,
  PartnerDealOwnerEnum,
  PartnerIntegrationModeEnum,
  PartnerSyncWebhookVersionEnum,
  PartnerTierEnum,
  PriceSettingTypeEnum,
  PricingCallMode,
  ProductAttachmentTypeEnum,
  ProductCommissionSettingCoefficientPropertyEnum,
  ProductCommissionSettingsBeneficiariesEnum,
  ProductCompensationSettingPropertyEnum,
  ProductDistributionModeEnum,
  ProductPricingProviderEnum,
  ProductPricingSettingCoefficientPropertyEnum,
  ProductProviderEnum,
  ProductProviderIdMapper,
  ProductProviderNameMapper,
  ProductTargetEnum,
  ProductTypeEnum,
  PublicationStatusEnum,
  RiskAttributionErrorTypesEnum,
  RiskAttributionReleaseErrorTypesEnum,
  RiskEventTypesEnum,
  RiskTriggerHandlingErrorTypesEnum,
  RouteModeEnum,
  SEYNA_CURRENCY,
  SEYNA_MAXIMUM_COMPENSATION_ALLOWED,
  STANDARD_LANGUAGES,
  ScheduledEmailReminderTypes,
  SeynaBinders,
  StopStatusEnum,
  StopStatusProviderEnum,
  StripePaymentIntentStatuses,
  SubscriptionPaymentStatuses,
  SubscriptionPaymentTypes,
  TRIP_PRICING_FACTORS,
  WITHDRAWAL_ALLOWED_COEFFICIENT_PROPERTIES,
  WakamPartnershipCodeEnum,
  doesFlexRequireCancellationProof,
  eir,
  ensuro,
  isCoefficientCompensationSettings,
  isCoefficientPricingSetting,
  isCommissionCoefficientPropertyAllowedForCoveredEvent,
  isCompensationPropertyAllowed,
  isPricingCoefficientPropertyAllowed,
  isPricingCoefficientPropertyAllowedForCoveredEvent,
  isProductClaimableByCustomer,
  isProductClaimableByPartner,
  isProductOnlyClaimableByCustomer,
  isProductOnlyClaimableByPartner,
  isProductWithClaimSettings,
  koala,
  nayms,
  requiresCancellationProof,
  seyna
};
//# sourceMappingURL=index.js.map